import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Button,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TableHead,
  IconButton,
  TableContainer,
  Paper,
} from '@material-ui/core';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';
import KenCard from '../../../global_components/KenCard';
import KenGrid from '../../../global_components/KenGrid';
import KenCheckbox from '../../../global_components/KenCheckbox/index';
import KenDialogBox from '../../../global_components/KenDialogBox';
import routes from '../../../Utils/routes.json';
import { RiEditLine, RiFilterLine } from 'react-icons/ri';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenPopover from '../../../Components/KenPopOver';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import KenSelect from '../../../global_components/KenSelect';
import KenButton from '../../../global_components/KenButton';
import KenInputField from '../../../global_components/KenInputField';
import KenAutoComplete from '../../../global_components/KenAutoComplete/index';
import { RiCheckFill } from 'react-icons/ri';
import AddIcon from '@material-ui/icons/Add';
import FacultyTable from '../AddProgram/FacultyTable';
import Checkbox from '@material-ui/core/Checkbox';
import EditIcon from '@material-ui/icons/EditOutlined';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import { AiOutlineDelete } from 'react-icons/ai';
import './styles.scss';
import AddActivity from '../AddActivity/addActivity';
import { todayDropDown, classRoomOptions } from '../AddProgram/data/data';
import { AiOutlineMinusSquare, AiOutlinePlusSquare } from 'react-icons/ai';
import KenGridEditable from '../../../global_components/kenEditDataGrid/kenGridEditable';
import KenSnackbar from '../../../Components/KenSnackbar/index';
import KenDialog from '../../../global_components/KenDialogBox';
import KenLoader from '../../../Components/KenLoader/index';
import SearchBox from '../../../Components/SearchBox/index';
import ResourceCalendar from '../FullCalendar/components/ResourceCalendar';
import ProgramFilters from '../ProgramFilters';
import FacultyProfile from '../FacultyProfiles/facultyProfile';
import AcademicCalendar from '../AcademicCalendar/index';
import AddMasterImport from './AddMasterImport';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { saveAs } from 'file-saver';
import { debounce } from 'lodash';
import {
  getAcademicFilter,
  getTermsAndCourseVersions,
  getDataForCourseEnrolment,
  postCourseVersionData,
  getImportTermwiseSubjectData,
  postCreateCourseVersionsAndActivites,
  getMasterSubjectsWithTermData,
  getSectionOfferingData,
  getActivitesWithCourseVersion,
  postSectionOfferingData,
  getFacultyAndFacilty,
  getCampusHolidaysData,
  postTermDatesUpdate,
  getFacultyAvailabilityBooking,
  getPlannedData,
  getFacultyBookingsData,
} from '../../../Utils/apiServices';
import { ArrowBack, ArrowForward } from '@material-ui/icons';
import SubjectUsers from '../../Users/subjectUsers';
const defaultValues = {
  startDate: '',
  endDate: '',
  courseName: [],
  courseId: '',
  activity: 'N/A',
  credit: '',
  facultyList: [],
  facility: '',
};
const FacultyCell = (row, popOverOpen, handleDialog) => {
  if (row) {
    return (
      <p onMouseEnter={(e) => popOverOpen(e)} onMouseLeave="normalImg(this)">
        {row}
      </p>
    );
  } else {
    return (
      <Button
        // className={classes.filterButton}
        variant="contained"
        color="primary"
        onClick={handleDialog}
      >
        Select CR/faculty
      </Button>
    );
  }
};
const arrayBreadCrumb = [{ head: 'BACK', url: routes.addActivity }];
const UserCell = (row, name, popOverOpen) => {
  return (
    <p style={{ marginRight: '10px' }} onMouseEnter={(e) => popOverOpen(e)}>
      <img
        style={{ borderRadius: '50%', marginRight: '10px' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />{' '}
      {name}
    </p>
  );
};
const availableCell = (rows) => {
  if (rows === 'available') {
    return <div style={{ color: '#1DE831' }}>available</div>;
  } else {
    return <div style={{ color: '#EF4060' }}>unavailable</div>;
  }
};
const useStyles = makeStyles((theme) => ({
  faculty_buttons: {
    marginLeft: '20rem',
  },
  add_faculty_button: {
    marginLeft: '2rem',
  },
  // checkbox: {
  //   marginTop: '24px',
  // },
  selectFacultyModal: {
    width: '10rem',
  },
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  filterButton: {
    marginRight: '5px',
    marginTop: 'auto',
  },
  actionBtns: {
    margin: '2px',
    borderRadius: '15px',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
    textTransform: 'none',
    fontWeight: 'bold',
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(6, 1fr)',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '13px',
    color: '#505F79',
    borderBottom: 'none',
  },

  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
  popOverTitle: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#ffffff',
    backgroundColor: '#092682',
    fontSize: '14px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  popoverMainTitle: {
    width: '100%',
    background: '#19228c',
    color: '#fff',
    padding: '7px 15px',
    fontWeight: '700',
  },
  customTableColumn: {
    color: '#02195E',
    fontWeight: '700',
  },
  customTableColumnPop: {
    color: '#02195E',
    borderBottom: 'none',
  },
  fetchingDetails: {
    justifyContent: 'center !important',
    width: '100%',
    fontWeight: 600,
    fontSize: '16px',
    textTransform: 'uppercase',
  },
  activeBtn: {
    background: '#1A251A',
    color: '#fff',
    borderRadius: 0,
    '&:hover': {
      background: '#1A251A',
      color: '#fff',
    },
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    textDecoration: 'none',
    textTransform: 'none',
    height: '28px',
    width: '78px',
    marginTop: '10px',

    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  defaultBtn: {
    background: '#2C3E50',
    color: '#fff',
    borderRadius: 0,
    '&:hover': {
      background: '#2C3E50',
      color: '#fff',
    },
  },
  calendarBtn: { marginTop: 'auto', marginRight: 8 },
  goBack: {
    margin: '0px',
    textAlign: 'right',
  },
}));
const AddSubject = () => {
  const createData = (
    id,
    weekNo,
    courseName,
    // courseId,
    activity,
    credit,
    startDate,
    endDate,
    section,
    facultyList,
    facility,
    saves
  ) => ({
    id,
    courseName,
    // courseId,
    activity,
    credit,
    startDate,
    endDate,
    section,
    facultyList,
    facility,
    saves,
  });

  const createSectionData = (
    id,
    checkbox,
    section,
    sectionStrength,
    facultyName,
    saves
  ) => ({
    id,
    checkbox,
    section,
    sectionStrength,
    facultyName,
    saves,
  });
  const createFacultyData = (
    id,
    checkbox,
    section,
    sectionStrength,
    facultyView,
    saves
  ) => ({
    id,
    checkbox,
    section,
    sectionStrength,
    facultyView,
    saves,
  });
  const selectClassRoom = [
    {
      id: 1,
      check: false,
      section: 'section',
      grade: 'A',
      startTime: '10:00 AM',
      endTime: '1:00PM',
      SelectClassroom: classRoomOptions,
      addFaculty: 'Add Faculty',
      icon: <AddIcon />,
    },
    {
      id: 2,
      check: false,
      section: 'section',
      grade: 'B',
      startTime: '11:00 AM',
      endTime: '3:00PM',
      SelectClassroom: classRoomOptions,
      addFaculty: 'Add Faculty',
      icon: <AddIcon />,
    },
    {
      id: 3,
      check: false,
      section: 'section',
      grade: 'C',
      startTime: '10:00 AM',
      endTime: '1:00PM',
      SelectClassroom: classRoomOptions,
      addFaculty: 'Prof Raju',
      icon: <RiEditLine size={15} />,
    },
  ];
  const masterHead = [
    {
      Header: '',
      accessor: 'cursor',
      disableGlobalFilter: false,
    },
    // {
    //   Header: 'Week No.',
    //   accessor: 'weekNo',
    //   disableGlobalFilter: false,
    // },
    {
      Header: 'Subject Code',
      accessor: 'courseId',
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject',
      accessor: 'courseName',
      disableGlobalFilter: false,
    },
    {
      Header: 'Specialization',
      accessor: 'specializationName',
      disableGlobalFilter: false,
    },
    // {
    //   Header: 'Duration in Weeks',
    //   accessor: 'durationInWeeks',
    //   disableGlobalFilter: false,
    // },
    {
      Header: 'Credits',
      accessor: 'credit',
      disableGlobalFilter: false,
    },
    {
      Header: 'Pre-Requisites ',
      accessor: 'PreRequisites',
      cell: ({ value }) => {
        return <Typography>{value?.join(',')}</Typography>;
      },
      disableGlobalFilter: false,
    },
    // {
    //   Header: 'CO-Requisites ',
    //   accessor: 'CoRequisites',
    //   cell: ({ value }) => {
    //     return <Typography>{value?.join(',')}</Typography>;
    //   },
    //   disableGlobalFilter: false,
    // },
    {
      Header: 'Offset',
      accessor: 'offset',
      disableGlobalFilter: false,
    },
    {
      Header: 'Duration',
      accessor: 'duration',
      disableGlobalFilter: false,
    },
  ];
  const SubjectHeader = [
    {
      Header: 'Week No',
      accessor: 'weekNo',
      disableGlobalFilter: false,
    },
    {
      Header: 'course Name',
      accessor: 'courseName',
      disableGlobalFilter: false,
    },
    {
      Header: 'activity',
      accessor: 'activity',
      disableGlobalFilter: false,
    },
    {
      Header: 'credit',
      accessor: 'credit',
      disableGlobalFilter: false,
    },
    {
      Header: 'start Date',
      accessor: 'startDate',
      Cell: (props) => {
        const custom_date = props.value
          ? moment(props.value).format('DD-MM-YYYY')
          : '';
        return (
          <Typography style={{ fontSize: '12px' }}>{custom_date}</Typography>
        );
      },
      disableGlobalFilter: false,
    },

    {
      Header: 'end Date',
      accessor: 'endDate',
      Cell: (props) => {
        const custom_date = props.value
          ? moment(props.value).format('DD-MM-YYYY')
          : '';
        return (
          <Typography style={{ fontSize: '12px' }}>{custom_date}</Typography>
        );
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'section',
      accessor: 'section',
      disableGlobalFilter: false,
    },
    {
      Header: 'faculty List',
      accessor: 'facultyList',
      disableGlobalFilter: false,
    },
  ];
  const facultyBooking = [
    {
      Header: 'Program',
      accessor: 'program',
      disableGlobalFilter: false,
    },
    {
      Header: 'Subject',
      accessor: 'subjectName',
      disableGlobalFilter: false,
    },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      Cell: (props) => {
        const custom_date = props.value
          ? moment(props.value).format('DD-MM-YYYY')
          : '';
        return (
          <Typography style={{ fontSize: '12px' }}>{custom_date}</Typography>
        );
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'End Date',
      accessor: 'endDate',
      Cell: (props) => {
        const custom_date = props.value
          ? moment(props.value).format('DD-MM-YYYY')
          : '';
        return (
          <Typography style={{ fontSize: '12px' }}>{custom_date}</Typography>
        );
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'Start Time',
      accessor: 'startTime',

      disableGlobalFilter: false,
    },
    {
      Header: 'End Time',
      accessor: 'endTime',
      disableGlobalFilter: false,
    },
    {
      Header: 'Booked Facilty',
      accessor: 'faciltyName',
      disableGlobalFilter: false,
    },
    {
      Header: 'Type',
      accessor: 'type',
      disableGlobalFilter: false,
    },
  ];
  const facultyAvailability = [
    {
      Header: 'Subject',
      accessor: 'subjectName',
      disableGlobalFilter: false,
    },
    {
      Header: 'Start Date',
      accessor: 'startDate',
      Cell: (props) => {
        const custom_date = props.value
          ? moment(props.value).format('DD-MM-YYYY')
          : '';
        return (
          <Typography style={{ fontSize: '12px' }}>{custom_date}</Typography>
        );
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'End Date',
      accessor: 'endDate',
      Cell: (props) => {
        const custom_date = props.value
          ? moment(props.value).format('DD-MM-YYYY')
          : '';
        return (
          <Typography style={{ fontSize: '12px' }}>{custom_date}</Typography>
        );
      },
      disableGlobalFilter: false,
    },
    {
      Header: 'Start Time',
      accessor: 'startTime',
      disableGlobalFilter: false,
    },
    {
      Header: 'End Time',
      accessor: 'endTime',
      disableGlobalFilter: false,
    },
  ];
  const classes = useStyles();
  const history = useHistory();
  const userDetails = localStorage.getItem('userDetails');
  const [startDay, setStartDay] = useState(todayDropDown[0].value);
  const [endDay, setEndDay] = useState(todayDropDown[0].value);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEls, setAnchorEls] = React.useState(null);
  const [startSubjectDate, setStartSubjectDate] = useState('');
  const [endSubjectDate, setEndSubjectDate] = useState('');
  const [filters, setFilters] = useState({});
  const [facultyDrop, setFacultyDrop] = useState({});
  const opens = Boolean(anchorEls);
  const [totalDay, setTotalDay] = useState('');
  const [totalHrWeek, setTotalHrWeek] = useState('');
  const ids = opens ? 'simple-popover' : undefined;
  const [sendBulkEmailDialog, setSendBulkEmailDialog] = useState(false);
  const [sendEmailDialog, setSendEmailDialog] = useState(false);
  const [filterDialog, setFilterDialog] = useState(false);
  const [facultyDialog, setFacultyDialog] = useState(false);
  const [selectAllData, setSelectAllData] = useState(false);
  const [cloneDialog, setCloneDialog] = useState(false);
  const [value, setValue] = React.useState('Online');
  const [formValues, setFormValues] = useState(defaultValues);
  const [noOfStudent, setNoOfStudent] = useState('');
  const [resourceType, setResourceType] = useState('facility');
  const [accordienCheck, setAccordienCheck] = useState(true);
  const [selectFaculty, setSelectFaculty] = useState(selectClassRoom);
  const [rowFaculty, setRowFaculty] = useState([]);
  const [facultyName, setFacultyName] = useState('');
  const [programName, setProgramName] = useState('');
  const [programPlanID, setProgramPlanID] = useState('');
  const [year, setYear] = useState('');
  const [intake, setIntake] = useState('');
  const [term, setTerm] = useState();
  const [termDropdown, setTermDropdown] = useState([]);
  const [loading, setLoading] = React.useState(false);
  const [campusOptions, setCampusOptions] = React.useState([]);
  const [courseOptions, setCourseOptions] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState([]);
  const [editIndex, setEditIndex] = useState();
  const [newActivity, setNewActivity] = useState(false);
  const [indexVal, setIndexVal] = useState();
  const [disableAddSubject, setDisableAddSubject] = useState(false);
  const [masterData, setMasterData] = useState([]);
  const [masterDialog, setMasterDialog] = useState(false);
  const [masterImportSuccess, setMasterImportSuccess] = useState(false);
  const [disableMaster, setDisableMaster] = useState(true);
  const [masterAccordian, setMasterAccordian] = useState(true);
  const [selectedAcademicProgram, setSelectedAcademicProgram] = useState();
  const [programID, setProgramID] = useState('');
  const [programPlanIDOptions, setProgramPlanIDOptions] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [sectionViewDialog, setSectionViewDialog] = useState(false);
  const [addSubjectDialog, setAddSubjectDialog] = useState(false);
  const [facultyData, setFacultyData] = useState([]);
  const [facultyViewDialog, setFacultyViewDialog] = useState(false);
  const [previous, setPrevious] = useState({});
  const [dataSubject, setDataSubject] = useState(defaultValues);
  const [newSectionData, setNewSectionData] = useState({});
  const [newFacultyData, setNewFacultyData] = useState({});
  const [activateDelete, setActivateDelete] = useState(true);
  const [activateEdit, setActivateEdit] = useState(false);
  const [checkedData, setCheckedData] = useState({});
  const [toggleReload, setToggleReload] = useState(false);
  const [editedItem, setEditedItem] = useState({});
  const [activityViewDialog, setActivityViewDialog] = useState(false);
  const [reviewFacultyDialog, setReviewFacultyDialog] = useState(false);
  const [reviewFacilityDialog, setReviewFacilityDialog] = useState(false);
  const [holidayListingDialog, setHolidayListingDialog] = useState(false);
  const [facultyProfileDialog, setFacultyProfileDialog] = useState(false);
  const [profileData, setProfileData] = useState([]);
  const [newAddActivity, addNewActivity] = useState(false);
  const [activitiesData, setActivitiesData] = useState([]);
  const [fetchingData, setFetchingData] = useState('Fetching ...');
  const [selectedTerm, setSelectedTerm] = useState();
  const [currentRow, setCurrentRow] = useState([]);
  const [disableMasterImport, setDisableMasterImport] = useState(false);
  const [searchString, setSearchString] = useState('');
  const [trigger, setTrigger] = useState(false);
  const [handleClick, sethandleClick] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);
  const [addIntoTerm, setAddIntoTerm] = useState({});
  const [addNewSubData, setAddNewSubData] = useState([]);
  const [facilityCell, setFacilityCell] = useState([]);
  const [holidayListData, setHolidayListData] = useState([]);
  const [disableBtn, setDisableBtn] = useState(true);
  const [contactId, setContactId] = useState();
  const [facilitySelected, setFacilitySelected] = useState(undefined);
  const [facultyAdded, setFacultyAdded] = useState(false);
  const [newAction, setNewAction] = useState(false);
  const [createNewActivity, setCreateNewActivity] = useState(false);
  const [termIdVal, setTermId] = useState('');
  const [expanded, setExpanded] = useState(0);
  const [facultyBookingData, setfacultyBookingData] = useState([]);
  const [facultyAvailabilityData, setfacultyAvailabilityData] = useState([]);
  const [selectedFaculty, setSelectedFaculty] = useState([]);
  const [actualData, setActualData] = useState([]);
  const [plannedData, setPlannedData] = useState([]);
  const [showAddMasterImport, setShowAddMasterImport] = useState(false);
  const [proceedMaster, setProceedMaster] = useState(false);
  const [newMasterUpload, setNewMasterUpload] = useState(false);
  const [importData, setImportData] = useState([]);
  const [workingDays, setWorkingDays] = React.useState('');
  const [showAcademicCalendarPopup, setShowAcademicCalendarPopup] =
    useState(false);
  const [facultyAvailabilityPopup, setFacultyAvailabilityPopup] =
    useState(false);

  const [programValue, setProgramValue] = useState({
    title: '',
    value: '',
  });
  const [programPlanval, setprogramPlanval] = useState({
    title: '',
    value: '',
  });

  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const location = useLocation();

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };
  const [serviceTabs] = useState([
    { index: 1, title: 'Actual' },
    { index: 2, title: 'Planned' },
    { index: 3, title: 'Both' },
  ]);

  const [itemIndex, setItemIndex] = React.useState(3);
  const [currentSelected, setCurrentSelected] = React.useState('Both');
  const [currentSectionFacultyOptions, setCurrentSectionFacultyOptions] =
    useState([]);
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const data = [
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Raleigh Avieson',
        handlePopoverOpen
      ),
      phone: 'Avieson',
      email: 'ravieson0@soup.io',
      type: 'internal',
      availability: availableCell('available'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Fleur Fowler',
        handlePopoverOpen
      ),
      phone: 'Fowler',
      email: 'ffowler1@ucla.edu',
      type: 'internal',
      availability: availableCell('available'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Nealy Leitch',
        handlePopoverOpen
      ),
      phone: 'Leitch',
      email: 'nleitch2@networkadvertising.org',
      type: 'internal',
      availability: availableCell('available'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Carolyne Angrock',
        handlePopoverOpen
      ),
      phone: 'Angrock',
      email: 'cangrock3@washingtonpost.com',
      type: 'internal',
      availability: availableCell('unavailable'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Abeu Aiers',
        handlePopoverOpen
      ),
      phone: 'Aiers',
      email: 'aaiers4@weibo.com',
      type: 'internal',
      availability: availableCell('unavailable'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Penny Scrivinor',
        handlePopoverOpen
      ),
      phone: 'Scrivinor',
      setSelectFaculty,
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Grier Laverick',
        handlePopoverOpen
      ),
      phone: 'Laverick',
      email: 'glaverick6@uol.com.br',
      type: 'internal',
      availability: availableCell('available'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Dur Leile',
        handlePopoverOpen
      ),
      phone: 'Leile',
      email: 'dleile7@spiegel.de',
      type: 'internal',
      availability: availableCell('available'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Claudine Owenson',
        handlePopoverOpen
      ),
      phone: 'Owenson',
      email: 'cowenson8@gizmodo.com',
      type: 'internal',
      availability: availableCell('available'),
    },
    {
      name: UserCell(
        'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
        'Stefa True',
        handlePopoverOpen
      ),
      phone: 'True',
      email: 'strue9@jigsy.com',
      type: 'internal',
      availability: availableCell('unavailable'),
    },
  ];
  const [selectOptionsCourse, setSelectOptionsCourse] = React.useState([]);
  const [selectOptionsCourseNEW, setSelectOptionsCourseNEW] = React.useState(
    []
  );
  const [selectSubjectCodeOption, setSelectSubjectCodeOption] = React.useState(
    []
  );
  const [dateValidate, setdateValidate] = useState('');
  const handleSelectAllRows = (state) => {
    // TODO code here to perform actions on selecting all rows in table
    setSelectAllData(state);
  };
  const handleSelectRow = (evt, row, index) => {
    setRowFaculty(row);
    console.log('row', row);
    // TODO code here to perform actions on selecting row in table
  };
  const handlefacultyDialog = () => {
    setFacultyDialog((prevState) => !prevState);
    // setRowFaculty([]);
  };
  const addFacultyName = (id) => {
    const rowId = [...rowFaculty, id];
    setRowFaculty(rowId);
    handlefacultyDialog();
  };
  const onClickCheckBox = (id) => {
    let uniqueArr = [];
    let rowId = [...rowFaculty, id];
    rowId.sort(function (a, b) {
      return a - b;
    });
    for (let i = 0; i <= rowId.length; i++) {
      if (rowId[i] == rowId[i + 1]) {
        i++;
      } else {
        uniqueArr.push(rowId[i]);
      }
    }
    setRowFaculty(uniqueArr);
  };
  const addFaculty = (id) => {
    handlefacultyDialog();
  };
  useEffect(() => {
    if (courseOptions.length > 0) {
      let academicProgram = sessionStorage.getItem('AcademicProgram');
      let programPlanId = sessionStorage.getItem('programPlanID');
      let ProgramPlan = sessionStorage.getItem('ProgramPlan');
      if (academicProgram && programPlanId && ProgramPlan) {
        academicProgram = JSON.parse(sessionStorage.getItem('AcademicProgram'));
        ProgramPlan = JSON.parse(sessionStorage.getItem('ProgramPlan'));
        setProgramValue(academicProgram);
        setprogramPlanval(ProgramPlan);
        setProgramPlanID(programPlanId);
        let temp = courseOptions.filter((item) => {
          return item?.title === academicProgram?.title;
        });
        handleAutocomplete('courseName', '', courseOptions, temp[0]);
      }
    }
  }, [courseOptions]);

  useEffect(() => {
    console.log('uniquestate', rowFaculty);
    const newFacultyList = selectFaculty.map((faculty) =>
      rowFaculty.includes(faculty.id)
        ? {
            ...faculty,
            addFaculty: facultyName,
            icon: <RiEditLine />,
          }
        : faculty
    );
    setSelectFaculty(newFacultyList);
  }, [facultyName]);

  function handleSendEmailDialog() {
    console.log('object');
    setSendEmailDialog((prevState) => !prevState);
  }
  const selectOptionsMode = [
    {
      label: 'F2F',
      value: 'f2f',
    },
    {
      label: 'Offline',
      value: 'offline',
    },
    {
      label: 'Online',
      value: 'online',
    },
  ];
  const taskOptions = [
    {
      label: 'Complete',
      value: '1',
    },
    {
      label: 'In Progress',
      value: '2',
    },
    {
      label: 'Yet to Complete',
      value: '3',
    },
  ];
  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsCourse[0]?.value
  );
  const [selectValueMode, setSelectValueMode] = useState(
    selectOptionsMode[0].value
  );
  const progressStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    color: 50 > 0 ? '#27AE60' : '#EF4060',
  };
  const progressStyle1 = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    color: 0 > 0 ? '#27AE60' : '#EF4060',
  };
  const [rowSubject, setRowSubject] = useState([]); // Table Row
  const handleFacultyDrop = (e) => {
    const { name, value } = e.target;
  };
  const checkAvailability = (row) => {
    let facultyDetail = { title: row?.facultyName, value: row?.facultyId };
    checkFacultyBookingData(facultyDetail);
    setSelectedFaculty(facultyDetail);
    setFacultyAvailabilityPopup(true);
  };
  const onChange = (e, row, multiVal) => {
    let edit = activateEdit;
    if (multiVal != undefined) {
      let data = (dataSubject.facultyList = multiVal);
      if (row?.facultyList.length < multiVal.length) {
        setFacultyAvailabilityPopup(true);
        let addedFaculty = multiVal[multiVal.length - 1];
        setSelectedFaculty(addedFaculty);
        checkFacultyBookingData(addedFaculty);
      }
      setDataSubject({ ...data });
      return (row.facultyList = multiVal);
    }
    if (row?.section) {
      if (edit === true) {
        let newData = sectionData;
        newData.forEach((item) => {
          if (item.id === row.id) {
            if (e.type === 'change') {
              item.sectionStrength = e.target.value;
            } else if (e.type === 'click') {
              item.facultyName = e.target.value;
            }
            return setEditedItem(item);
          }
        });
        setSectionData(newData);
      }
      if (e.target.checked) {
        row.checkbox = e.target.checked;
        setCheckedData(row);
      }
    }
    if (e.target.type === 'checkbox') {
      setActivateDelete(!activateDelete);
      setActivateEdit(false);
      return edit == false;
    }
    const selectedOption = selectOptionsCourse.filter((item) => {
      if (item.value === e.target.value) {
        return item;
      }
    });
    const setData = selectedOption[0];
    console.log('rrrrrrrrrrrrrrrrrrrrrrrrrrrr', setData);
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { courseRecordId } = row;
    const newData = [...rowSubject];
    newData[editIndex]?.array.forEach((row) => {
      if (row.courseRecordId === courseRecordId) {
        console.log('vvvvvvvvvvvvvvvvvvvvvvvvvvvvv', value);
        if (setData) {
          row[name] = value;
          row['courseId'] = setData?.courseId;
          row['credit'] = setData?.credit;
        } else {
          row[name] = value;
          if (row[name] === 'startDate') {
            let currentEndDay = moment(row.endDate).format('dddd');
            let selected = row?.workingDays.split(';');
            if (selected.includes(currentEndDay)) {
              let subStartDate = row.startDate;
              let subEndDate = moment(row.startDate, 'YYYY-MM-DD;HH:mm:ss')
                .add(row.termDuration, 'weeks')
                .format('YYYY-MM-DD');
              return {
                ...row,
                startDate: subStartDate,
                endDate: subEndDate,
              };
            } else {
              let nextDay;
              let daysAdded;
              let updatedDate;
              let m1 = moment(row.startDate, 'YYYY-MM-DD;HH:mm:ss')
                .add(row.termDuration, 'weeks')
                .format('YYYY-MM-DD');
              let convertedDays = selected.map((item2) => {
                return moment().day(item2).weekday();
              });
              const currentDayInt = moment().day(currentEndDay).weekday();
              const intCheck = convertedDays.some((val) => {
                return val > currentDayInt;
              });
              if (intCheck) {
                nextDay = convertedDays.filter((val) => {
                  return val > currentDayInt;
                })[0];
              } else {
                nextDay = Math.min(...convertedDays);
              }
              if (currentDayInt <= nextDay) {
                daysAdded = nextDay - currentDayInt;
                updatedDate = moment(m1).add(daysAdded, 'days');
              } else {
                daysAdded = Number(7) - currentDayInt + nextDay;
                updatedDate = moment(m1).add(daysAdded, 'days');
              }
              console.log('Updated End Date', updatedDate.format('YYYY-MM-DD'));
              let subStartDate = row.startDate;
              let subEndDate = updatedDate.format('YYYY-MM-DD');
              return {
                ...row,
                startDate: subStartDate,
                endDate: subEndDate,
              };
            }
          }
        }
      }
    });
    setRowSubject(newData);
  };
  const checkFacultyBookingData = async (faculty) => {
    setfacultyBookingData([]);
    setLoading(true);
    let facultyBookingActual = [];
    let facultyBookingPlanned = [];
    let querryNew = `facultyId=${faculty?.value}`;
    let plannedData = await getPlannedData(querryNew);
    if (!plannedData.message) {
      if (Object.values(plannedData).length > 0) {
        Object.values(plannedData).map((items) => {
          items.map((item) => {
            facultyBookingPlanned.push({
              program: item?.programPlanName,
              subjectName: item?.subjectCourseName,
              startDate: moment(item.startDate).format('L'),
              endDate: moment(item.endDate).format('L'),
              startTime: '-',
              endTime: '-',
              faciltyName: item.facilityName,
              type: 'Planned',
            });
          });
        });
        setPlannedData(facultyBookingPlanned);
      }
    }
    let actualData = await getFacultyBookingsData({
      facultyId: faculty?.value,
    });
    if (!actualData.message) {
      if (Object.values(actualData).length > 0) {
        Object.values(actualData).map((item) => {
          facultyBookingActual.push({
            program: item?.programPlanName,
            subjectName: item?.subjectName,
            startDate: moment(item.startDate).format('L'),
            endDate: moment(item.endDate).format('L'),
            startTime: moment(item.startDate).format('LT'),
            endTime: moment(item.endDate).format('LT'),
            faciltyName: item.facilityName,
            type: 'Actual',
          });
        });
        setActualData(facultyBookingActual);
      }
    }
    setfacultyBookingData([...facultyBookingActual, ...facultyBookingPlanned]);
    setLoading(false);
  };
  useEffect(() => {
    if (actualData.length > 0 || plannedData.length > 0) {
      if (currentSelected === 'Actual') {
        setfacultyBookingData([...actualData]);
      } else if (currentSelected === 'Planned') {
        setfacultyBookingData([...plannedData]);
      } else if (currentSelected === 'Both') {
        setfacultyBookingData([...actualData, ...plannedData]);
      }
    }
  }, [currentSelected]);

  const dateFormatter = (date) => {
    let dArr = date?.split('-');
    return dArr[2] + '/' + dArr[1] + '/' + dArr[0];
  };
  const onToggleEditMode = (check, id, index) => {
    const newData = [...rowSubject];
    newData[index]?.array.forEach((row) => {
      if (row.courseVersionId === id) {
        row.isEditMode = true;
        if (check === 'done') {
          if (row?.startDate === null) {
            console.log('bfvhafgfdjui');
            setdateValidate('Please enter vaild date');
          } else {
            setdateValidate('');
            setLoading(true);
            let facultyIds = row?.facultyList.map((el) => {
              return `${el.title}-${el.value}`;
            });
            console.log('row?.startDate', row?.startDate);
            const payload = {
              CourseVersion: {
                termName: newData[index]?.courseName,
                facultyWithId: facultyIds?.toString(),
                courseVersionId: row.courseVersionId,
                courseId: row?.courseRecordId,
                startDate:
                  row?.startDate === null
                    ? null
                    : dateFormatter(row?.startDate),
                endDate:
                  row?.endDate === null ? null : dateFormatter(row?.endDate),
              },
            };
            postCourseVersionData(payload)
              .then((res) => {
                setLoading(false);
                handleSnackbarOpen('success', res.message);
                row.isEditMode = false;
                setRowSubject(newData);
                console.log('newDat', newData);
                setDisableAddSubject(false);
                setNewAction(!newAction);
              })
              .catch((err) => {
                handleSnackbarOpen('error', err.message);
                setLoading(false);
                row.isEditMode = false;
                setRowSubject(newData);
                console.log('newDat', newData);
                setDisableAddSubject(false);
              });
          }
        } else if (check === 'edit') {
          setDisableAddSubject(true);
          row.isEditMode = true;
          setRowSubject(newData);
        }
      }
    });
    setEditIndex(index);
  };
  const onDeleteSubject = (id, rowData, index) => {
    setLoading(true);
    let payload = {
      Operation: 'Delete',
      CourseVersion: {
        courseVersionId: id,
      },
    };
    postCourseVersionData(payload)
      .then((res) => {
        console.log(res);
        setLoading(false);
        setNewAction(!newAction);
        setDisableAddSubject(false);
        handleSnackbarOpen('success', res.message);
      })
      .catch((err) => {
        setLoading(false);
        handleSnackbarOpen('error', err.message);
      });
  };
  const onRevert = (id, rowSubject, index) => {
    setDisableAddSubject(false);
    const newData = [...rowSubject];
    newData[index].array.map((row) => {
      if (row.courseVersionId === id) {
        return (row.isEditMode = false);
      }
    });
    setRowSubject(newData);
    setNewAction(!newAction);
  };
  const handleCancel = (row, rowSubject, index) => {
    setDisableAddSubject(false);
    const newData = [...rowSubject];
    newData[index].array.pop((item) => item.courseVersionId === row);
    setRowSubject(newData);
  };
  const columnArray = [
    'Week No.',
    'Subject',
    // 'Subject Code',
    'Activity',
    'Credits',
    'Start Date',
    'End Date',
    'Section',
    'Faculty',
    'Facility',
    'Action',
  ];
  const sectionArray = ['', 'Section', 'Section Strength', 'Faculty', 'Action'];
  const facultyArray = ['', 'Section', 'Section Strength', 'Faculty', 'Action'];

  const [facultyOptions, setFacultyOptions] = useState([]);
  const handlePopoverClose = () => {
    setAnchorEls(null);
  };
  const handleSelectChangeSubject = (event, index) => {
    setLoading(true);
    dataSubject.courseName = event.target.value;
    setSelectValueSubject(event.target.value);
    const newData = [...selectOptionsCourse];
    const selectedOption = newData.filter((item) => {
      if (item.value === event.target.value) {
        return item;
      }
    });
    const setData = selectedOption[0];
    setDataSubject({
      ...dataSubject,
      courseName: setData.value,
      courseId: setData.courseId,
      credit: setData.credit,
      id: setData.id,
    });
    console.log('============', setData, event.target.value);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const handleSelectChangeSubjectNEW = (e, value) => {
    dataSubject.courseName = value;
    if (value != null) {
      dataSubject.courseId = value?.courseId;
    } else {
      dataSubject.courseId = '';
    }
    setDataSubject({ ...dataSubject, ['courseName']: value });
  };
  const handleFilter = (e, data) => {
    const { name, value, id } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
    if (e.target.name === 'courseName') {
      console.log('e.target.value', data);
      setRowSubject([]);
      // sessionStorage.setItem('programName', value);
      setProgramName(value);
      let newData = data.filter((element) => {
        return element.label === e.target.value;
      });
      setProgramID(newData[0]?.id);
      // sessionStorage.setItem('programID', newData[0]?.id);
      let termData = [];
      newData[0]?.terms.map((item) => {
        termData.push({ label: item.name, value: item.name });
      });
      termData.push({ label: 'All', value: 'All' });
      // setProgramID(newData[0].id)
      setTermDropdown(termData);
      setTerm(undefined);
    } else if (e.target.name === 'intake') {
      sessionStorage.setItem('intake', value);
      setIntake(value);
    } else if (e.target.name === 'year') {
      sessionStorage.setItem('year', value);
      setYear(value);
    } else if (e.target.name === 'ProgramPlan') {
      setProgramPlanID(value);
      setDisableMaster(false);
    }
  };
  const handleAutocomplete = (name, e, data, objValue) => {
    console.log('ttt', objValue);
    if (name == 'courseName') {
      if (objValue != null) {
        setFilters({
          ...filters,
          [name]: objValue?.title,
        });
        setRowSubject([]);
        setFetchingData('');
        setProgramName(objValue?.title);
        let newData = objValue;
        setProgramID(newData?.id);
        setProgramValue({
          title: newData?.title,
          value: newData?.value,
        });
        sessionStorage.setItem(
          'AcademicProgram',
          JSON.stringify({ title: newData?.title, value: newData?.value })
        );
        let termData = [];
        newData?.terms.map((item) => {
          termData.push({ title: item.name, value: item.name });
        });
        termData.push({ title: 'All', value: 'All' });
        setTermDropdown(termData);
        setTerm(undefined);
      } else {
        setFilters({ ...filters, [name]: '' });
        setProgramName('');
        setProgramID('');
        setProgramValue({ title: '', value: '' });
        setTermDropdown([]);
        setprogramPlanval({ title: '', value: '' });
        setProgramPlanIDOptions([]);
        setFetchingData('');
        setRowSubject([]);
      }
    } else if (name == 'ProgramPlan') {
      if (objValue != null) {
        setFilters({
          ...filters,
          [name]: objValue?.value,
        });
        setFetchingData('Fetching Data...');
        setProgramPlanID(objValue?.value);
        setprogramPlanval({
          title: objValue.title,
          value: objValue.value,
        });
        sessionStorage.setItem(
          'ProgramPlan',
          JSON.stringify({ title: objValue.title, value: objValue.value })
        );
        sessionStorage.setItem('programPlanID', objValue?.value);
        setDisableMaster(false);
      } else {
        setFilters({ ...filters, [name]: '' });
        setProgramPlanID('');
        setFetchingData('');
        setprogramPlanval({ title: '', value: '' });
        setDisableMaster(false);
        setRowSubject([]);
      }
    }
  };

  const onReload = () => {
    showActivitiesData(selectedRow[0].courseVersionId);
    addNewActivity(false);
  };
  const manageStartDate = (e) => {};
  function handleSendEmailDialog() {
    console.log('object');
    setSendEmailDialog((prevState) => !prevState);
  }
  const manageEndDate = (e) => {};
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const handleChangedCredit = (event) => {
    dataSubject.credit = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };
  const handleChangedSubjectCode = (event) => {
    dataSubject.courseId = event;
    const select = selectSubjectCodeOption.filter((item) => {
      if (item.label == event) {
        return item;
      }
    });
    setSelectSubjectCodeOption(select);
  };
  const handleChangedStudent = (event) => {
    dataSubject.student = event.target.value;
    // setDataStream({ ...dataStream, [event.target.name]: event.target.value })
  };
  const handleChangedDate = (event, dataSub) => {
    let selectedDate = event.target.value;
    let currentStartDay = moment(selectedDate).format('dddd');
    let selected = dataSub?.workingDays.split(';');
    if (!selected.includes(currentStartDay)) {
      handleSnackbarOpen('info', 'Selected start date is not a working day');
    }
    if (dataSub?.termDuration != null) {
      let duration = Number(dataSub?.termDuration);
      let newEndDate = moment(selectedDate)
        .add(duration, 'weeks')
        .format('YYYY-MM-DD');
      let endWorkingDay = moment(newEndDate).format('dddd');
      if (selected.includes(endWorkingDay)) {
        dataSubject.endDate = newEndDate;
        setDataSubject({
          ...dataSubject,
          [event.target.name]: selectedDate,
          endDate: newEndDate,
        });
      } else {
        let nextDay;
        let daysAdded;
        let updatedDate;
        let m1 = moment(dataSubject.startDate)
          .add(duration, 'weeks')
          .format('YYYY-MM-DD');
        let convertedDays = selected.map((item2) => {
          return moment().day(item2).weekday();
        });
        const currentDayInt = moment().day(newEndDate).weekday();
        const intCheck = convertedDays.some((val) => {
          return val > currentDayInt;
        });
        if (intCheck) {
          nextDay = convertedDays.filter((val) => {
            return val > currentDayInt;
          })[0];
        } else {
          nextDay = Math.min(...convertedDays);
        }
        if (currentDayInt <= nextDay) {
          daysAdded = nextDay - currentDayInt;
          updatedDate = moment(m1).add(daysAdded, 'days');
        } else {
          daysAdded = Number(7) - currentDayInt + nextDay;
          updatedDate = moment(m1).add(daysAdded, 'days');
        }
        console.log('Updated End Date', updatedDate.format('YYYY-MM-DD'));
        let subStartDate = dataSubject.startDate;
        let subEndDate = updatedDate.format('YYYY-MM-DD');
        setDataSubject({
          ...dataSubject,
          [event.target.name]: subStartDate,
          endDate: subEndDate,
        });
      }
    } else {
      dataSubject.startDate = selectedDate;
      setDataSubject({
        ...dataSubject,
        [event.target.name]: selectedDate,
      });
    }
  };
  const handleChangedEndDate = (event, dataSub) => {
    let currentEndDay = moment(event.target.value).format('dddd');
    let selected = dataSub?.workingDays.split(';');
    if (selected.includes(currentEndDay)) {
      dataSubject.endDate = event.target.value;
      setDataSubject({
        ...dataSubject,
        [event.target.name]: event.target.value,
      });
    } else {
      handleSnackbarOpen('info', 'Selected end date is not a working day');
    }
  };
  const handleSubjectChangedDate = (event) => {
    console.log('event', event);
  };
  const handleChangeFaculty = (event, value) => {
    dataSubject.facultyList = value;
    setDataSubject({ ...dataSubject, ['facultyList']: value });
    console.log('name', dataSubject);
  };
  const handleSubject = (check, id, index) => {
    setDisableAddSubject(true);
    if (check == 'save') {
      setLoading(true);
      let savedData = dataSubject;
      let termName = id.courseName;
      const facultyIds = savedData?.facultyList.map((el) => {
        return `${el.title}-${el.value}`;
      });
      console.log('facultyIds', facultyIds.toString());
      const payload = {
        CourseVersion: {
          termName: termName,
          courseVersionId: null,
          facultyWithId: facultyIds?.toString(),
          courseId: savedData?.courseName?.id,
          startDate: dateFormatter(savedData.startDate),
          endDate: dateFormatter(savedData.endDate),
        },
      };
      postCourseVersionData(payload)
        .then((res) => {
          setNewActivity(!newActivity);
          setLoading(false);
          setDataSubject(defaultValues);
          setAddSubjectDialog(false);
          setDisableAddSubject(false);
          handleSnackbarOpen('success', res.message);
        })
        .catch((err) => {
          setLoading(false);
          handleSnackbarOpen('error', err.message);
          setDisableAddSubject(false);
        });
    } else {
      const newData = [...rowSubject];
      newData[index]?.array.push(
        createData(
          `rows${rowSubject[index]?.array.length}`,
          <p>{dataSubject.weekNo}</p>,
          <KenSelectWrap
            label="Subject"
            options={selectOptionsCourse}
            value={dataSubject.courseName}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleSelectChangeSubject(e, index)}
            required
          />,
          // <p>{dataSubject.courseId}</p>,
          <p>{dataSubject.activity}</p>,
          <p>{dataSubject.credit}</p>,
          <>
            <KenDateTimePicker
              name={'startDate'}
              value={dataSubject.startDate}
              label="Start date"
              type="date"
              required={true}
              // defaultValue={startData}
              onChange={(e) => handleChangedDate(e)}
            />
            <p style={{ color: 'red' }}>{dateValidate}</p>
          </>,
          <KenDateTimePicker
            name={'endDate'}
            placeholder="Start Time"
            label="End date"
            value={dataSubject.endDate}
            type="date"
            required={true}
            onChange={(e) => handleChangedEndDate(e)}
          />,
          <p>View</p>,
          <KenAutoComplete
            options={facultyOptions}
            label="Faculty"
            value={dataSubject.facultyList}
            variant="outlined"
            onChange={(e, value) => handleChangeFaculty(e, value)}
            required
          />,
          true
        )
      );
      setRowSubject(newData);
      setIndexVal({ id, newData, index });
    }
  };

  const handleAddSubject = (data, index) => {
    console.log('data, index', data);
    setAddIntoTerm(data);
    setAddNewSubData(data);
    setAddSubjectDialog(true);
  };
  const downloadTermSubject = (dataObj) => {
    if (dataObj) {
      const unit = 'pt';
      const size = 'A4'; // Use A1, A2, A3 or A4
      const orientation = 'portrait'; // portrait or landscape
      const marginLeft = 40;
      const doc = new jsPDF(orientation, unit, size);
      doc.setFontSize(12);
      const title = ` S P Jain's Term-Wise Subject List \n \n`;
      const headers = [
        ['Subject', 'Start Date', 'End Date', 'Faculty', 'Facility'],
      ];
      doc.text(title, marginLeft, 40);
      doc.line(40, 65, 580, 65, 'S');
      let pdfData = [];
      dataObj?.array.map((el) => {
        pdfData.push({
          ...el,
        });
      });
      pdfData.sort(function (a, b) {
        return new Date(b.startDate) - new Date(a.startDate);
      });
      console.log('pdfData', pdfData);
      const data = pdfData.map((elt) => [
        elt.courseName,
        elt.startDate,
        elt.endDate,
        elt.facility != 'View' ? elt.facility : '-',
        elt.facultyList.map((item2) => {
          return `${item2.title}`;
        }),
      ]);

      var finalY = doc.lastAutoTable.finalY || 40;
      let content = {
        theme: 'grid',
        startY: finalY + 60,
        head: headers,
        body: data,
      };
      doc.text(dataObj?.courseName, marginLeft, finalY + 40);
      doc.autoTable(content);
      doc.save(`Subject List ${dataObj?.courseName}.pdf`);
    }
  };
  const getWeeksDiff = (days) => {
    let weeks = parseInt(days / 7);
    days = days - weeks * 7;
    return (
      (weeks > 0 ? weeks + ' week' + (weeks > 1 ? 's ' : ', ') : '') +
      (days > 0 ? days + ' day' + (days > 1 ? 's ' : '') : '')
    );
  };

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }
  function handleCloneDialog() {
    setCloneDialog((prevState) => !prevState);
  }
  const stringSplit = (text) => {
    var inputText = text.replace(/\s/g, '');
    var output = [];
    var json = inputText?.split(' ');
    json.forEach(function (item) {
      output.push(item?.replace(/\'/g, '').split(/(\d+)/).filter(Boolean));
    });
    return output;
  };
  const masterImportCancel = () => {
    // setMasterData([]);
    setMasterDialog(false);
  };
  const masterImportSubmit = () => {
    setLoading(true);
    const masterData = selectedTerm?.masterData;
    let courseListData = [];
    masterData?.array.map((item) => {
      courseListData.push({
        courseid: item.id,
        startDate: item?.startDate,
        endDate: item?.endDate,
        examRequired: false,
        subjectOffset: item?.offset,
        activitesList: item?.activitesList.map((item2) => ({
          activityName: item2?.activityName,
          activityType: item2?.activityType,
          startDate: item2?.startDate,
          endDate: item2?.endDate,
          activityOffset: item2?.offset,
          activityDuration: item2?.duration,
        })),
      });
    });
    let payload = [
      {
        termId: selectedTerm?.elem?.termId,
        courseList: courseListData,
      },
    ];
    postCreateCourseVersionsAndActivites(payload)
      .then((res) => {
        if (res.success === 'false') {
          handleSnackbarOpen('error', res.message);
        } else {
          handleSnackbarOpen('success', res.message);
          setMasterImportSuccess(!masterImportSuccess);
          setMasterDialog(false);
          setNewAction(!newAction);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log('error', error);
        handleSnackbarOpen('error', error.message);
      });
  };

  const handleAddToMasterImport = (data) => {
    setShowAddMasterImport(true);
    setImportData(data);
  };

  useEffect(() => {
    let newSelects = [];
    selectedUser.map((item) => {
      newSelects.push({ title: item.facultyName, value: item.facultyId });
    });
    let newArr = rowSubject;
  }, [selectedUser]);

  // ********************************** Section View *******************************************
  const returnSectionChar = (char) => {
    let newChar = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return newChar.charAt(char);
  };
  const onToggleCancelBtn = (row, sectionData, index) => {
    const newData = [...sectionData];
    newData.pop((item) => item.id === row);
    setSectionData(newData);
    setNewSectionData({});
  };
  const handleSectionStrength = (event) => {
    let tempData = newSectionData;
    tempData.sectionStrength = event.target.value;
    setNewSectionData({
      ...newSectionData,
      ['sectionStrength']: event.target.value,
    });
  };
  const handleSectionFaculty = (event) => {
    let tempData = newSectionData;
    tempData.facultyName = event.target.value;
    setNewSectionData({
      ...newSectionData,
      ['facultyName']: event.target.value,
    });
  };
  const handleSectionNameChange = (event) => {
    let tempData = newSectionData;
    tempData.section = event.target.value;
    setNewSectionData({ ...newSectionData, ['section']: event.target.value });
  };
  const onToggleSaveBtn = (check, data, index) => {
    if (check == 'save') {
      setLoading(true);
      let newData = newSectionData;
      let replaceString = String(newData?.section)
        .toLowerCase()
        .replace('section ', '');
      let payload = {
        Operation: 'Create',
        CourseOffering: {
          courseOfferingSectionId: String(replaceString).toUpperCase(),
          courseOfferingCapacity: newData?.sectionStrength,
          courseOfferingId: '',
          courseVersionId: selectedRow[0]?.courseVersionId,
          coursePrimaryFaculty: newData?.facultyName,
        },
      };
      console.log('payload', payload);
      postSectionOfferingData(payload)
        .then((res) => {
          console.log('res', res);
          sectionData.forEach((item) => {
            item.isEditMode = false;
          });
          setSectionData(data);
          setToggleReload(!toggleReload);
          setNewSectionData({});
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };
  const addToSectionData = (check, id, index) => {
    if (check === 'add') {
      const newData = [...sectionData];
      // var tempData = newSectionData;
      // tempData.section = `Section `; //${returnSectionChar(sectionData.length)}
      // setNewSectionData({['section']: `Section `});
      newData.push(
        createSectionData(
          `rows${sectionData.length}`,
          <KenCheckbox
            name={`checkbox`}
            className={classes.checkbox}
            value={newSectionData.checkbox}
            onChange={(event) => selectedCheckBoxItem(event, id)}
            color="primary"
          />,
          <KenInputField
            label={'Section'}
            value={newSectionData.section}
            optionalLabel={false}
            placeholder="eg. Section A"
            onChange={(event) => handleSectionNameChange(event, id)}
            // disabled={true}
            style={{ fontSize: 12 }}
          />,
          <KenInputField
            label={'Section Strength'}
            value={newSectionData.sectionStrength}
            optionalLabel={false}
            onChange={(e) => handleSectionStrength(e)}
            style={{ fontSize: 12 }}
          />,
          <KenSelectWrap
            label="Faculty"
            options={currentSectionFacultyOptions}
            value={newSectionData.facultyName}
            dropdownColor="#FFFFFF"
            onChange={(e) => handleSectionFaculty(e)}
            required
          />,
          true
        )
      );
      console.log('new section data', newData);
      setSectionData(newData);
    } else {
      let selectedData = checkedData;
      setLoading(true);
      let payload = {
        Operation: 'Delete',
        CourseOffering: {
          courseOfferingId: selectedData.id,
        },
      };
      console.log('payload', payload);
      postSectionOfferingData(payload)
        .then((res) => {
          console.log('res', res);
          sectionData.forEach((item) => {
            item.isEditMode = false;
          });
          setSectionData(data);
          setToggleReload(!toggleReload);
          setActivateDelete(true);
        })
        .catch((err) => {
          setLoading(false);
          setActivateDelete(true);
        });
    }
  };
  // Section Data EDIT AND SUBMIT
  const onToggleEditBtn = (check, data, index) => {
    const newData = [...sectionData];
    console.log('selectedRow', selectedRow);
    newData.forEach((row) => {
      if (row.id === data.id) {
        row.isEditMode = true;
        if (check === 'done') {
          console.log('r', row);
          setLoading(true);
          let replaceString = String(editedItem?.section).replace(
            'Section ',
            ''
          );
          let payload = {
            Operation: 'Update',
            CourseOffering: {
              courseOfferingSectionId: replaceString,
              courseOfferingCapacity: Number(editedItem?.sectionStrength),
              courseOfferingId: editedItem?.id,
              courseVersionId: selectedRow[0].courseVersionId,
              coursePrimaryFaculty: row.facultyName,
            },
          };
          console.log('payload', payload);
          postSectionOfferingData(payload)
            .then((res) => {
              setToggleReload(!toggleReload);
            })
            .catch((err) => {
              setLoading(false);
            });
        } else if (check === 'edit') {
          setActivateEdit(true);
          row.isEditMode = true;
          setSectionData(newData);
        }
      }
    });
  };
  const onToggleRevertBtn = (id, sectionData, index) => {
    const newData = [...sectionData];
    newData.map((row) => {
      if (row.id === id) {
        return (row.isEditMode = false);
      }
    });
    setSectionData(newData);
    setToggleReload(!toggleReload);
  };
  const sectionCell = (item) => {
    let data = [];
    data.push(item);
    setSelectedRow(data);
    let facultyOptions = [];
    data[0].facultyList.map((item) => {
      facultyOptions.push({ label: item.title, value: item.value });
    });
    setCurrentSectionFacultyOptions(facultyOptions);
    setSectionViewDialog(true);
  };
  React.useEffect(() => {
    setLoading(true);
    let params = `courseVersionId=${selectedRow[0]?.courseVersionId}`;
    getSectionOfferingData(params)
      .then((res) => {
        let data = [];
        if (res.message != 'No Data Found') {
          Object.entries(res).map((items) => {
            data.push({
              section:
                items[1]?.courseOfferingSectionId != null
                  ? `Section ${items[1].courseOfferingSectionId}`
                  : '',
              id: items[1].id,
              checkbox: false,
              sectionStrength: items[1].courseOfferingCapacity,
              facultyName: items[1]?.facultyName,
            });
          });
        }
        setSectionData(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setSectionData([]);
      });
  }, [toggleReload, selectedRow]);
  const sectionViewCancel = () => {
    setSectionViewDialog(false);
  };
  const sectionViewSubmit = () => {
    setSectionViewDialog(false);
  };
  const selectedCheckBoxItem = (event, newdata) => {
    console.log('checkbox', event, newdata);
  };
  // ********************************** Section View *******************************************
  const editCell = (cell, row, selectedRow) => {
    if (cell === 'section') {
      sectionCell(row);
    } else if (cell === 'faculty') {
      facultyCell(row);
    } else if (cell === 'activity') {
      activityCell(row);
      setCurrentRow(selectedRow);
      addNewActivity(false);
      setActivitiesData([]);
      setFetchingData('Fetching ...');
    } else if (cell === 'facility') {
      if (row?.startDate != null && row?.endDate != null) {
        showActivitiesData(row?.courseVersionId);
        setReviewFacilityDialog(true);
        setFacilityCell(row);
      } else {
        handleSnackbarOpen('info', 'Please add start and end dates');
      }
    }
  };
  React.useEffect(() => {
    const facultyData = [
      {
        id: 'secA',
        checkbox: false,
        section: 'Section A',
        sectionStrength: 50,
        facultyView: '',
      },
      {
        id: 'secB',
        checkbox: false,
        section: 'Section B',
        sectionStrength: 40,
        facultyView: 'Prof. Pranav',
      },
    ];
    setFacultyData(facultyData);
  }, []);
  // ********************************** Faculty View *******************************************
  const facultyCell = (item) => {
    let data = [];
    data.push(item);
    setSelectedRow(data);
    setFacultyViewDialog(true);
    console.log('facultyCell', item);
  };
  const facultyViewCancel = () => {
    setFacultyViewDialog(false);
  };
  const facultyViewSubmit = () => {
    setFacultyViewDialog(false);
  };
  const handleSelectFaculty = (e) => {
    let tempData = newFacultyData;
    tempData.faculty = e.target.value;
  };
  // const addToFacultyData = (check, id, index) => {
  //   const newData = [...facultyData];
  //   let tempData = newFacultyData;
  //   tempData.section = `Section ${returnSectionChar(facultyData.length)}`;
  //   setNewFacultyData(tempData);
  //   newData.push(
  //     createFacultyData(
  //       `rows${facultyData.length}`,
  //       <KenCheckbox
  //         name={`checkbox`}
  //         className={classes.checkbox}
  //         value={newFacultyData.checkbox}
  //         onChange={(event) => selectedCheckBoxItem(event, facultyData)}
  //         color="primary"
  //       />,
  //       <KenInputField
  //         label={'Section'}
  //         value={newFacultyData.section}
  //         optionalLabel={false}
  //         disabled={true}
  //         style={{ fontSize: 12 }}
  //       />,
  //       <KenInputField
  //         label={'Section Strength'}
  //         value={newFacultyData.sectionStrength}
  //         optionalLabel={false}
  //         onChange={(e) => handleSectionStrength(e)}
  //         style={{ fontSize: 12 }}
  //       />,
  //       <KenSelectWrap
  //         label="Faculty"
  //         options={facultyOptions}
  //         value={newFacultyData.faculty}
  //         dropdownColor="#FFFFFF"
  //         onChange={(e) => handleSelectFaculty(e)}
  //         required
  //       />,
  //       true
  //     )
  //   );
  //   console.log('new section data', newData);
  //   setFacultyData(newData);
  // };
  const onFacultyCancelBtn = (row, data, index) => {
    const newData = [...facultyData];
    newData.pop((item) => item.id === row);
    setFacultyData(newData);
  };
  const handleFacultyStrength = (event) => {
    newFacultyData.sectionStrength = event.target.value;
  };
  const onFacultySaveBtn = (check, data, index) => {
    if (check == 'save') {
      data.forEach((item) => {
        item.isEditMode = false;
      });
      setFacultyData(data);
    }
  };
  const onFacultyEditBtn = (check, id, index) => {
    const newData = [...facultyData];
    newData.forEach((row) => {
      if (row.id === id) {
        row.isEditMode = true;
        if (check === 'done') {
          row.isEditMode = false;
          setRowSubject(newData);
        } else if (check === 'edit') {
          row.isEditMode = true;
          setFacultyData(newData);
        }
      }
    });
  };
  const onFacultyRevertBtn = (id, facultyData, index) => {
    const newData = [...facultyData];
    newData.map((row) => {
      if (row.id === id) {
        return (row.isEditMode = false);
      }
    });
    setFacultyData(newData);
  };
  const addFacultyToAll = () => {};
  // ********************************** Faculty View *******************************************
  useEffect(async () => {
    const faciltiyAndFacultyData = await getFacultyAndFacilty();
    if (!faciltiyAndFacultyData?.error) {
      const AllFacultyObject = Object.values(faciltiyAndFacultyData?.Faculty);
      const AllfacultyData = AllFacultyObject.map((fData) => {
        return { title: fData.facultyName, value: fData.id };
      });
      setFacultyOptions(AllfacultyData);
    }
  }, []);
  useEffect(async () => {
    const AcademicFilter = await getAcademicFilter();
    if (!AcademicFilter?.error) {
      const AcademicFilterObject = Object.entries(AcademicFilter?.Courses);
      const subjectOptionsNew = AcademicFilterObject.map(([item, keyVal]) => {
        return {
          title: item,
          label: keyVal?.courseName,
          value: item,
          id: keyVal?.id,
          courseId: keyVal?.courseId,
          academicId: keyVal?.courseAcademicProgramId,
        };
      });

      if (programID != undefined) {
        const subjectOptions = [];
        subjectOptionsNew.map((item) => {
          if (item?.academicId === programID) {
            subjectOptions.push(item);
          }
        });
        setSelectOptionsCourseNEW(subjectOptions);
      }
    }
  }, [programID]);
  // ********************************** Activity View *******************************************

  const activityCell = (item) => {
    let data = [];
    data.push(item);
    setSelectedRow(data);
    setActivityViewDialog(true);
    showActivitiesData(data[0]?.courseVersionId);
    let facultyOptions = [];
    data[0].facultyList.map((item) => {
      facultyOptions.push({ label: item.title, value: item.value });
    });
    setCurrentSectionFacultyOptions(facultyOptions);
    console.log('activityCell', item);
  };
  const activityViewCancel = () => {
    setActivityViewDialog(false);
  };
  const activityViewSubmit = () => {
    setActivityViewDialog(false);
  };
  const addActivityItem = () => {
    setCreateNewActivity(true);
    addNewActivity(!newAddActivity);
  };
  // Activity GET API
  const showActivitiesData = (courseVersionId) => {
    setLoading(true);
    setActivitiesData([]);
    getActivitesWithCourseVersion(courseVersionId)
      .then((res) => {
        if (res?.data?.length > 0) {
          setActivitiesData(res?.data);
        } else {
          setActivitiesData([]);
          setFetchingData('No Data');
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setActivitiesData([]);
        setFetchingData('No Data');
      });
  };

  // ********************************** Activity View *******************************************

  React.useEffect(() => {
    setLoading(true);
    let programIDProp = history?.location?.state?.id || programID;
    setProgramID(programIDProp);
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        let campusOptions = [];
        let subjectOptions = [];
        let subjectCodeOptions = [];
        Object.entries(res['Academic Program']).map(([item, keyVal]) => {
          courseOptions.push({
            title: item,
            value: item,
            id: keyVal?.id,
            alias: keyVal?.alias,
            terms: JSON.parse(keyVal.terms),
          });
        });
        Object.entries(res['Campus']).map(([item, keyVal]) => {
          campusOptions.push({ label: item, value: item });
        });
        Object.entries(res['Courses']).map(([item, keyVal]) => {
          subjectOptions.push({
            label: item,
            value: item,
            credit: keyVal.credit,
            id: keyVal.id,
            courseId: keyVal.courseId,
          });
          subjectCodeOptions.push({
            label: keyVal.courseId != null ? keyVal.courseId : '-',
            value: keyVal.id,
          });
        });
        setSelectOptionsCourse(subjectOptions);
        setSelectSubjectCodeOption(subjectCodeOptions);
        setCourseOptions(courseOptions);
        setCampusOptions(campusOptions);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);
  // GET PROGRAM PLAN ID
  React.useEffect(() => {
    setLoading(true);
    const data = JSON.parse(userDetails);
    const instituteId = data?.Id;
    if (programID !== '') {
      console.log('programID', programID);
      getDataForCourseEnrolment(instituteId)
        .then((res) => {
          let programPlanData = Object.entries(
            res?.ProgramPlanForEachAcedemicProgram
          ).filter((item) => {
            if (item[0] === programID) {
              return item;
            }
          });
          if (programPlanData.length > 0) {
            let programPlanIDOptions = [];
            programPlanData[0][1].map((items) => {
              programPlanIDOptions.push({
                title: items.ProgramPlanName,
                value: items.ProgramPlanId,
              });
            });
            setProgramPlanIDOptions(programPlanIDOptions);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [programID, programName, userDetails]);
  useEffect(() => {
    if (location?.state?.intake) {
      const program = programPlanIDOptions.filter((items) => {
        return items.label === location.state.intake;
      });
      setProgramPlanID(program[0]?.value);
    }
  }, [location, programPlanIDOptions]);
  useEffect(() => {
    if (location?.state?.programName) {
      setProgramName(location?.state?.programName);
      let newData = courseOptions.filter((element) => {
        return element.label === location.state.programName;
      });
      console.log('newDatanewDatanewData', newData);
      setProgramID(newData[0]?.id);
    }
  }, [location, courseOptions]);
  // GET PROGRAM TABLE DATA
  React.useEffect(() => {
    if (programPlanID !== '') {
      console.log('programPlanID', programPlanID);
      setLoading(true);
      getTermsAndCourseVersions(programPlanID)
        .then((res) => {
          console.log(res, 'res');
          if (res.data.length > 0) {
            let alteredData = res?.data.map((item, index) => {
              let sortName = item.termName.split('-');
              let currentTerm = sortName[3];
              console.log('sortName', sortName);
              setWorkingDays(item.workingDays);
              // setStartSubjectDate(item.termStartDate);
              // setEndSubjectDate(item.termEndDate);
              return {
                courseName: item.termName,
                termId: item.termId,
                termName: item.termName,
                termStartDate: item.termStartDate,
                campusId: item.campusId,
                currentTerm: currentTerm,
                termEndDate: item.termEndDate,
                masterTermId: item.masterTermId,
                termDuration: item.termDuration,
                workingDays: item.workingDays,
                weekNo: item.weekNo,
                array: item.courseVersion.map((items) => ({
                  ...items,
                  activity: 'View',
                  section: 'View',
                  facility:
                    items.facility != undefined ? items.facility : 'View',
                  facultyList: items.facultyList.map((el) => ({
                    title: el?.facultyName,
                    value: el.facultyId,
                  })),
                })),
              };
            });
            let disableMasterImport = alteredData.every(
              (item) => item.array.length > 0
            );
            setDisableMasterImport(disableMasterImport);
            alteredData.sort((a, b) => {
              if (a.currentTerm < b.currentTerm) {
                return -1;
              }
              if (a.currentTerm > b.currentTerm) {
                return 1;
              }
              return 0;
            });
            console.log('alteredData', alteredData);
            setRowSubject(alteredData);
            setReviewFacultyDialog(false);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [programPlanID, newActivity, facultyAdded, newAction]);
  const handleCurriculamImport = async (e, elem) => {
    setMasterData([]);
    setLoading(true);
    let alteredData = {};
    let termNo = stringSplit(elem?.currentTerm);
    let querry = `?academicProgramId=${programID}&termNumber=${termNo[0][1]}`;
    getMasterSubjectsWithTermData(querry)
      .then((res) => {
        console.log(res);
        let responseData = res?.message;
        if (responseData != undefined || responseData === 'No Data Found') {
          setMasterData([]);
          handleSnackbarOpen(
            'info',
            'Curriculam Import is not available for this academic program'
          );
        } else {
          alteredData = res.map((item) => {
            let courseListData = [];
            item?.specialWrapperList.map((item2) => {
              return item2.courseList.map((item3) => {
                item3.specializationName = item2.specializationName;
                courseListData.push(item3);
              });
            });
            console.log('courseListData', courseListData);
            return {
              courseName: item?.termName,
              termId: item.termId,
              array: courseListData,
            };
          });
          setMasterData(alteredData);
          let mastersData = alteredData;
          if (elem?.termStartDate != null && elem?.termEndDate != null) {
            mastersData[0]?.array.forEach((item) => {
              item.startDate = moment(elem?.termStartDate)
                .add(item?.offset, 'days')
                .format('YYYY-MM-DD');
              item.activitesList.forEach((item2) => {
                let activityDuration = item2?.offset + item2?.duration;
                item2.startDate = moment(elem?.termStartDate)
                  .add(item2?.offset, 'days')
                  .format('YYYY-MM-DD');
                item2.endDate = moment(elem?.termStartDate)
                  .add(activityDuration, 'days')
                  .format('YYYY-MM-DD');
              });
              var date = item.activitesList.sort(
                (a, b) => b.endDate - a.endDate
              );
              item.endDate = date[0]?.endDate;
            });
          } else {
            mastersData[0]?.array.forEach((item) => {
              item.startDate = null;
              item.endDate = null;
              item.activitesList.forEach((item2) => {
                item2.startDate = null;
                item2.endDate = null;
              });
            });
          }
          setSelectedTerm({
            elem,
            masterData: mastersData[0],
          });
          console.log('selectedTerm', { elem, masterData: mastersData[0] });
          let checkData = alteredData.find(
            (el) => el.termId === elem.masterTermId
          );
          // if (checkData == undefined) {
          //   setDisableMasterImport(true);
          // } else {
          //   setDisableMasterImport(false);
          // }
          setMasterDialog(true);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (newMasterUpload) {
      handleCurriculamImport('', selectedTerm.elem);
    }
  }, [newMasterUpload]);

  const handleTermStartDate = (e, elem, index) => {
    console.log('rowSubject', rowSubject);
    setStartSubjectDate(e.target.value);
    setTermId(elem?.termId);
    handleTermDateChange(
      'termStartDate',
      elem.termStartDate != null ? elem.termStartDate : e.target.value
    );
    setRowSubject((prev) => {
      return prev.map((item) => {
        if (item.termId === elem.termId) {
          // Date Change
          let currentEndDay = moment(e.target.value)
            .add(item.termDuration, 'weeks')
            .format('dddd');
          let defaultDays =
            'Monday;Tuesday;Wednesday;Thursday;Friday;Saturday;Sunday';
          let selected =
            item?.workingDays != null
              ? item?.workingDays.split(';')
              : defaultDays.split(';');
          if (selected.includes(currentEndDay)) {
            let termStartDate = e.target.value;
            let termEndDate = moment(e.target.value, 'YYYY-MM-DD;HH:mm:ss')
              .add(item.termDuration, 'weeks')
              .format('YYYY-MM-DD');
            handleTermAutoDateChange(termStartDate, termEndDate, item);
            return {
              ...item,
              termStartDate: termStartDate,
              termEndDate: termEndDate,
            };
          } else {
            let nextDay;
            let daysAdded;
            let updatedDate;
            let m1 = moment(e.target.value, 'YYYY-MM-DD;HH:mm:ss')
              .add(item.termDuration, 'weeks')
              .format('YYYY-MM-DD');
            let convertedDays = selected.map((item2) => {
              return moment().day(item2).weekday();
            });
            const currentDayInt = moment().day(currentEndDay).weekday();
            const intCheck = convertedDays.some((val) => {
              return val > currentDayInt;
            });
            if (intCheck) {
              nextDay = convertedDays.filter((val) => {
                return val > currentDayInt;
              })[0];
            } else {
              nextDay = Math.min(...convertedDays);
            }
            if (currentDayInt <= nextDay) {
              daysAdded = nextDay - currentDayInt;
              updatedDate = moment(m1).add(daysAdded, 'days');
            } else {
              daysAdded = Number(7) - currentDayInt + nextDay;
              updatedDate = moment(m1).add(daysAdded, 'days');
            }
            console.log('Updated End Date', updatedDate.format('YYYY-MM-DD'));
            let termStartDate = e.target.value;
            let termEndDate = updatedDate.format('YYYY-MM-DD');
            handleTermAutoDateChange(termStartDate, termEndDate, item);
            return {
              ...item,
              termStartDate: e.target.value,
              termEndDate: updatedDate.format('YYYY-MM-DD'),
            };
          }
        } else {
          return item;
        }
      });
    });
  };
  const handleTermEndDate = (e, elem, index) => {
    console.log('rowSubject', rowSubject);
    if (elem.termStartDate != null) {
      setStartSubjectDate(elem.termStartDate);
    }
    setEndSubjectDate(e.target.value);
    setTermId(elem?.termId);
    handleTermDateChange(
      'endDate',
      elem.termEndDate != null ? elem.termEndDate : e.target.value
    );
    setRowSubject((prev) => {
      return prev.map((item) => {
        if (item.termId === elem.termId) {
          return {
            ...item,
            termEndDate: e.target.value,
          };
        } else {
          return item;
        }
      });
    });
  };
  useEffect(() => {
    if (endSubjectDate) {
      handleTermDateChange('endDate', endSubjectDate);
    } else if (startSubjectDate) {
      handleTermDateChange('termStartDate', startSubjectDate);
    }
  }, [endSubjectDate, startSubjectDate]);

  const handleTermAutoDateChange = (termStartDate, termEndDate, item) => {
    setLoading(true);
    let payload = [
      {
        termId: item.termId,
        startDate: termStartDate,
        endDate: termEndDate,
      },
    ];
    postTermDatesUpdate(payload)
      .then((res) => {
        setLoading(false);
        handleSnackbarOpen('success', res.message);
        setTermId('');
        setStartSubjectDate('');
        setEndSubjectDate('');
        setFacultyAdded(!facultyAdded);
        setNewAction(!newAction);
      })
      .catch((err) => {
        setLoading(false);
        handleSnackbarOpen('error', err.message);
      });
  };
  const handleTermDateChange = (type, date) => {
    if (termIdVal != '' && startSubjectDate != null && endSubjectDate != null) {
      setLoading(true);
      let payload = [
        {
          termId: termIdVal,
          startDate: type === 'termStartDate' ? date : startSubjectDate,
          endDate: type === 'termEndDate' ? date : endSubjectDate,
        },
      ];
      postTermDatesUpdate(payload)
        .then((res) => {
          setLoading(false);
          handleSnackbarOpen('success', res.message);
          setTermId('');
          setStartSubjectDate('');
          setEndSubjectDate('');
          setFacultyAdded(!facultyAdded);
          setNewAction(!newAction);
        })
        .catch((err) => {
          setLoading(false);
          handleSnackbarOpen('error', err.message);
        });
    }
  };
  // ********************************** Review Faculty *******************************************
  const onHyperClick = (e, row, value) => {
    console.log('e, row, value', e, row, value);
    setReviewFacultyDialog(true);
    setSelectedSubject(row);
  };
  const reviewFacultyCancel = () => {
    setReviewFacultyDialog(false);
    sethandleClick(false);
  };
  const reviewFacultySubmit = () => {
    sethandleClick(true);
  };
  const reviewFacilityCancel = () => {
    setReviewFacilityDialog(false);
  };
  const reviewFacilitySubmit = () => {
    // TO ADD FACILITIES
    if (facilitySelected != undefined) {
      console.log('facilityCell', facilityCell);
      let facultyIds;
      if (facilityCell.facultyList.length > 0) {
        facultyIds = facilityCell?.facultyList.map((el) => {
          return `${el.title}-${el.value}`;
        });
      }
      let selectedRowSubject = [];
      rowSubject.forEach((item) => {
        item.array.forEach((item2) => {
          if (item2.courseRecordId === facilityCell.courseRecordId) {
            selectedRowSubject.push(item);
            return (item2.facility = facilitySelected.facilityName);
          }
        });
      });
      console.log('selectedRowSubject', selectedRowSubject);
      const payload = {
        CourseVersion: {
          termName: selectedRowSubject[0]?.courseName,
          facultyWithId: facultyIds?.toString(),
          courseVersionId: facilityCell.courseVersionId,
          courseId: facilityCell?.courseRecordId,
          facility: facilitySelected?.id,
          startDate: dateFormatter(facilityCell.startDate),
          endDate: dateFormatter(facilityCell.endDate),
        },
      };
      postCourseVersionData(payload)
        .then((res) => {
          setLoading(false);
          handleSnackbarOpen('success', res.message);
          setReviewFacilityDialog(false);
        })
        .catch((err) => {
          setLoading(false);
          handleSnackbarOpen('error', err.message);
        });
    }
  };
  const searchTable = (event) => {
    if (event != null) {
      const searchString = event?.target?.value;
      setSearchString(searchString);
      debouncedSearch();
    }
  };
  const handleSubmitFilters = () => {
    setTrigger(!trigger);
  };
  const debouncedSearch = debounce(handleSubmitFilters, 1000);
  // ********************************** Review Faculty *******************************************

  const handleAddSubjectCancel = () => {
    setAddSubjectDialog(false);
    setDataSubject(defaultValues);
  };
  const currentDataRequirement = (item) => {
    setItemIndex(item.index);
    setCurrentSelected(item.title);
  };
  const handleHolidayListing = async (e, elem) => {
    let params = `?campusId=${elem?.campusId}`;
    const holidayData = await getCampusHolidaysData(params);
    if (holidayData.length > 0) {
      let filteredList = holidayData.sort(
        (a, b) =>
          new Date(a?.startDate).getTime() - new Date(b?.startDate).getTime()
      );
      console.log('filteredList', filteredList);
      setHolidayListData(filteredList);
      setHolidayListingDialog(true);
    }
  };
  const holidayListingCancel = () => {
    setHolidayListingDialog(false);
  };
  const holidayListingSubmit = () => {};

  const handleProfileView = (faculty, row) => {
    setFacultyProfileDialog(true);
    setFacilityCell(row);
    let data = [];
    data.push(faculty);
    setProfileData(data);
  };
  const facultyProfileCancel = () => {
    setFacultyProfileDialog(false);
  };
  const facultyProfileSubmit = () => {
    setFacultyProfileDialog(false);
  };
  const facultyAvailabilityCancel = () => {
    setFacultyAvailabilityPopup(false);
  };
  const facultyAvailabilitySubmit = () => {
    setFacultyAvailabilityPopup(false);
  };
  const academicCalendarSubmit = () => {
    setShowAcademicCalendarPopup(false);
  };
  const addMasterClose = () => {
    setShowAddMasterImport(false);
  };
  const addNewMaster = () => {
    setProceedMaster(true);
  };
  const academicCalendarCancel = () => {
    setShowAcademicCalendarPopup(false);
  };
  const openAcademicCalendar = () => {
    setShowAcademicCalendarPopup(true);
  };
  const handleSelectChange2 = () => {
    setProgramName('');
    setWorkingDays('');
    setProgramID('');
    setProgramValue({
      title: '',
      value: '',
    });
    setprogramPlanval({
      title: '',
      value: '',
    });
    sessionStorage.setItem('AcademicProgram', '');
    sessionStorage.setItem('programPlanID', '');
    sessionStorage.setItem('ProgramPlan', '');
    setProgramPlanIDOptions([]);
    setRowSubject([]);
    // setRows([])
    // setProgramPlanIDOptions([])
  };

  return (
    <Box>
      {loading && <KenLoader />}
      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Grid container xs={12}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" className={classes.title}>
                Term-Wise Subject List
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} className={classes.goBack}>
              <Button
                variant="secondary"
                color="primary"
                style={{ marginRight: '10px', border: '1px solid #272727' }}
                onClick={() => {
                  history.push({
                    pathname: `${routes.academicCalendar}`,
                  });
                }}
              >
                <ArrowBack /> Academic Calendar
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  history.push({
                    pathname: `${routes.sessionScheduler}`,
                  });
                }}
              >
                Academic Planner
                <ArrowForward />
              </Button>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      {/* Filters */}
      <Box mt={2} mb={2} className={classes.sortingSection}>
        <div className="accal">
          <KenAutoComplete
            name="courseName"
            options={courseOptions}
            label="Academic Program "
            value={programValue}
            onChange={(el, value) =>
              handleAutocomplete('courseName', el, courseOptions, value)
            }
            required={true}
            multiple={false}
          />
        </div>
        {/* <KenSelect
          name="courseName"
          label="Academic Program *"
          options={courseOptions}
          value={programName}
          dropdownColor="#ffffff"
          onChange={(el) => handleFilter(el, courseOptions)}
          required={true}
        /> */}
        {/* <KenSelect
          name="ProgramPlan"
          label="Program Plan *"
          options={programPlanIDOptions}
          value={programPlanID}
          dropdownColor="#ffffff"
          onChange={(el) => handleFilter(el, programPlanIDOptions)}
          required={true}
        /> */}

        <div className="accal">
          <KenAutoComplete
            name="ProgramPlan"
            label="Program Plan"
            options={programPlanIDOptions}
            value={programPlanval}
            dropdownColor="#ffffff"
            onChange={(el, value) =>
              handleAutocomplete('ProgramPlan', el, programPlanIDOptions, value)
            }
            required={true}
            multiple={false}
          />
        </div>
        <Button
          variant="contained"
          color="primary"
          style={{ width: 100, marginTop: '18px' }}
          className={classes.addButton}
          onClick={handleSelectChange2}
        >
          Clear All
        </Button>

        <Grid style={{ transform: 'translateY(25%)' }}>
          {workingDays ? (
            <p>
              <b>Working Days: </b>
              {workingDays}
            </p>
          ) : null}
        </Grid>
        {/* <Button
          href={routes.sessionScheduler}
          variant="contained"
          color="primary"
          target="_blank"
          style={{ padding: '0 8px', fontSize: '12px', width: '210px' }}
        >
          Faculty/Facility Availability
        </Button> */}
      </Box>
      {/* Student Data */}
      <>
        {rowSubject.length > 0 ? (
          rowSubject.map((elem, index) => {
            return (
              <Box className="cardlsitbox" style={{ marginBottom: '20px' }}>
                <Accordion
                  expanded={expanded === index && accordienCheck ? true : false}
                >
                  <AccordionSummary
                    expandIcon={accordienCheck}
                    style={{ position: 'relative' }}
                  >
                    <div>
                      {expanded === index && accordienCheck ? (
                        <AiOutlineMinusSquare
                          size={20}
                          onClick={() => {
                            setExpanded(index);
                            setAccordienCheck(!accordienCheck);
                          }}
                        />
                      ) : (
                        <AiOutlinePlusSquare
                          size={20}
                          onClick={() => {
                            setExpanded(index);
                            setAccordienCheck(!accordienCheck);
                          }}
                        />
                      )}{' '}
                      &nbsp; {elem.courseName}
                    </div>
                    {accordienCheck ? (
                      <div
                        style={{
                          display: 'flex',
                          position: 'absolute',
                          right: 0,
                          top: 8,
                        }}
                      >
                        <div style={{ marginRight: '12px' }}>
                          <KenDateTimePicker
                            name={'startDate'}
                            value={elem?.termStartDate}
                            label="Start date"
                            type="date"
                            required={true}
                            onChange={(e) =>
                              handleTermStartDate(e, elem, index)
                            }
                          />
                        </div>
                        <div style={{ marginRight: '12px' }}>
                          <KenDateTimePicker
                            name={'endDate'}
                            label="End date"
                            value={elem?.termEndDate}
                            minDate={elem?.termStartDate}
                            type="date"
                            required={true}
                            onChange={(e) => handleTermEndDate(e, elem, index)}
                          />
                        </div>
                        <KenButton
                          // href={`${routes.academicCalendar}`} //?tId=${elem?.termId}
                          onClick={(e) => openAcademicCalendar(e, elem)}
                          // target="_blank"
                          variant="primary"
                          className={classes.calendarBtn}
                        >
                          Academic Calendar
                        </KenButton>
                        <KenButton
                          className={classes.filterButton}
                          variant="primary"
                          // color="primary"
                          onClick={(e) => handleCurriculamImport(e, elem)}
                          // disabled={disableMaster}
                        >
                          Curriculum Import
                        </KenButton>
                        <KenButton
                          className={classes.filterButton}
                          variant="primary"
                          onClick={(e) => handleHolidayListing(e, elem)}
                        >
                          Holiday List
                        </KenButton>
                      </div>
                    ) : null}
                  </AccordionSummary>
                  <KenCard elevation={0}>
                    <Grid container xs={12}>
                      <Grid item xs={8}>
                        <h5 style={{ margin: '0 20px 10px 10px' }}>Subjects</h5>
                      </Grid>
                      <Grid item xs={4} style={{ textAlign: 'right' }}>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          style={{ marginRight: '10px' }}
                          onClick={() => downloadTermSubject(elem)}
                        >
                          Download
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          onClick={() => handleAddSubject(elem, index)}
                          disabled={disableAddSubject}
                        >
                          Add Subjects
                        </Button>
                      </Grid>
                    </Grid>
                    <hr></hr>
                    <TableContainer component={Paper} className="subject-table">
                      <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                        <TableHead>
                          <TableRow>
                            {columnArray.map((ele) => (
                              <TableCell>{ele}</TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {elem?.array?.length > 0 ? (
                            elem?.array.map((row) => {
                              return (
                                <TableRow key={row.courseVersionId}>
                                  <KenGridEditable
                                    {...{
                                      row,
                                      onChange,
                                      onHyperClick,
                                      editCell,
                                      dateValidate,
                                      onAutoCompleteClick: (faculty) => {
                                        handleProfileView(faculty, row);
                                        console.log('Faculty: ', row);
                                        // history.push({
                                        //   pathname: `${routes.facultyProfile}/${faculty.value}`,
                                        //   state: {
                                        //     facultyId: faculty.value,
                                        //     courseId: row?.courseRecordId,
                                        //   },
                                        // });
                                      },
                                      columns: [
                                        {
                                          column_name: 'weekNo',
                                          is_inline_edit: false,
                                          inline_edit_type: '',
                                        },
                                        {
                                          column_name: 'courseName',
                                          is_inline_edit: false,
                                          inline_edit_type: 'kenSelect',
                                          dropdown: selectOptionsCourseNEW,
                                        },
                                        // {
                                        //   column_name: 'courseId',
                                        //   is_inline_edit: false,
                                        //   inline_edit_type: '',
                                        //   // dropdown: selectSubjectCodeOption,
                                        // },
                                        {
                                          column_name: 'activity',
                                          is_inline_edit: false,
                                          inline_edit_type: 'linkItem',
                                          selectedRow: elem,
                                        },
                                        {
                                          column_name: 'credits',
                                          is_inline_edit: false,
                                          inline_edit_type: '',
                                        },
                                        {
                                          column_name: 'startDate',
                                          is_inline_edit: true,
                                          inline_edit_type: 'kenDatePicker1',
                                        },
                                        {
                                          column_name: 'endDate',
                                          is_inline_edit: true,
                                          inline_edit_type: 'kenDatePicker1',
                                          // dropdown: selectOptionsBatch,
                                        },
                                        {
                                          column_name: 'section',
                                          is_inline_edit: false,
                                          inline_edit_type: 'linkItem',
                                        },
                                        {
                                          column_name: 'facultyList',
                                          is_inline_edit: false,
                                          inline_edit_type: 'kenAutoComplete',
                                          dropdown: facultyOptions,
                                          hyperLink: 'Add Faculty',
                                        },
                                        {
                                          column_name: 'facility',
                                          is_inline_edit: false,
                                          inline_edit_type: 'linkItem',
                                        },
                                      ],
                                    }}
                                  />
                                  <TableCell
                                    className={classes.selectTableCell}
                                    style={{ textAlign: 'center' }}
                                  >
                                    {row.isEditMode ? (
                                      <>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                          onClick={() =>
                                            onToggleEditMode(
                                              'done',
                                              row.courseVersionId,
                                              index
                                            )
                                          }
                                        >
                                          Save
                                        </Button>
                                        <IconButton
                                          aria-label="delete"
                                          onClick={() =>
                                            onDeleteSubject(
                                              row.courseVersionId,
                                              rowSubject,
                                              index
                                            )
                                          }
                                        >
                                          <AiOutlineDelete />
                                        </IconButton>
                                        <IconButton
                                          aria-label="revert"
                                          onClick={() =>
                                            onRevert(
                                              row.courseVersionId,
                                              rowSubject,
                                              index
                                            )
                                          }
                                        >
                                          <RevertIcon />
                                        </IconButton>
                                      </>
                                    ) : (
                                      <>
                                        {!row.saves && (
                                          <IconButton
                                            aria-label="edit"
                                            onClick={() =>
                                              onToggleEditMode(
                                                'edit',
                                                row.courseVersionId,
                                                index
                                              )
                                            }
                                          >
                                            <EditIcon />
                                          </IconButton>
                                        )}
                                        {row.saves && (
                                          <>
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              onClick={() =>
                                                handleSubject(
                                                  'save',
                                                  row,
                                                  index
                                                )
                                              }
                                            >
                                              Save
                                            </Button>
                                            <IconButton
                                              aria-label="revert"
                                              onClick={() =>
                                                handleCancel(
                                                  row.courseVersionId,
                                                  rowSubject,
                                                  index
                                                )
                                              }
                                            >
                                              <RevertIcon />
                                            </IconButton>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableRow>
                              {' '}
                              <TableCell
                                className={classes.noDataFound}
                                colSpan={12}
                                align="center"
                              >
                                No Data
                              </TableCell>{' '}
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </KenCard>
                </Accordion>
              </Box>
            );
          })
        ) : (
          <div className="empty-card">
            <KenGrid
              columns={SubjectHeader}
              data={[]}
              pagination={{ disabled: true }}
              toolbarDisabled={true}
            />
          </div>
        )}
      </>
      {/* Select Classroom / Faculty */}
      <Box className={classes.selectFacultyModal}>
        <KenDialogBox
          title={
            <Grid container>
              <Typography variant="h6" className={classes.dialogHeader}>
                Select Class Room/Faculty
              </Typography>
              <div className={classes.faculty_buttons}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => history.push(routes.facultySection)}
                >
                  Invite Faculty
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  // style={{ marginLeft: '180px', padding: '6px 24px 6px 24px' }}
                  onClick={() => addFaculty()}
                  className={classes.add_faculty_button}
                >
                  Add Faculty
                </Button>
              </div>
            </Grid>
          }
          open={sendEmailDialog}
          icon={<RiCheckFill />}
          // maxWidth="md"
          maxWidth="md"
          handleClose={() => handleSendEmailDialog()}
          negativeButtonClick={() => handleSendEmailDialog()}
          positiveButtonClick={() => handleSendEmailDialog()}
          positiveButtonText="Submit"
          negativeButtonText="Cancel"
          dividers
        >
          <Grid container spacing={4}>
            <Table>
              <TableBody>
                {selectFaculty.map((classRoom) => {
                  return (
                    <TableRow>
                      <TableCell className={`${classes.tableBodyStyle}`}>
                        <div className={classes.checkbox}>
                          <Checkbox
                            name="checkedF"
                            onChange={(e) => onClickCheckBox(classRoom.id)}
                            color="primary"
                          />
                        </div>
                      </TableCell>
                      <TableCell className={`${classes.tableBodyStyle}`}>
                        {classRoom.section}
                      </TableCell>
                      <TableCell
                        className={`${classes.customTableColumnPop} ${classes.tableBodyStyle}`}
                      >
                        {classRoom.grade}
                      </TableCell>
                      <TableCell
                        className={`${classes.customTableColumnPop} ${classes.tableBodyStyle}`}
                      >
                        {classRoom.startTime}
                      </TableCell>
                      <TableCell
                        className={`${classes.customTableColumnPop} ${classes.tableBodyStyle}`}
                      >
                        {classRoom.endTime}
                      </TableCell>
                      <TableCell className={classes.tableBodyStyle}>
                        <KenSelectWrap
                          name="classroom"
                          label="Select Classroom"
                          options={classRoom.SelectClassroom}
                          value={filters.campus}
                          dropdownColor="#FFFFFF"
                          onChange={handleFilter}
                          required
                        />
                      </TableCell>
                      <TableCell
                        className={`${classes.customTableColumnPop} ${classes.tableBodyStyle}`}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            onClick={(e) => addFacultyName(classRoom.id)}
                            style={{ cursor: 'pointer' }}
                          >
                            {classRoom.addFaculty}{' '}
                          </div>
                          <div style={{ marginLeft: '5px' }}>
                            {classRoom.icon}
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </KenDialogBox>
      </Box>
      {/* Select Faculty */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Select Faculty{' '}
          </Typography>
        }
        open={facultyDialog}
        // icon={<RiCheckFill />}
        handleClose={() => handlefacultyDialog()}
        negativeButtonClick={() => handlefacultyDialog()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        hidePositiveButton={true}
        maxWidth="lg"
        dividers
      >
        <Grid container spacing={3}>
          <FacultyTable
            data={data}
            setFacultyName={setFacultyName}
            handlefacultyDialog={handlefacultyDialog}
            selectFaculty={selectFaculty}
            setSelectFaculty={setSelectFaculty}
            rowFaculty={rowFaculty}
          />
        </Grid>
      </KenDialogBox>
      {/* Master Subject Import */}
      <KenDialog
        title={
          <>
            <Typography variant="h6" className={classes.dialogHeader}>
              Master Subject Import
            </Typography>
          </>
        }
        open={masterDialog}
        icon={<RiCheckFill />}
        handleClose={() => masterImportCancel()}
        negativeButtonClick={() => masterImportCancel()}
        positiveButtonClick={() => masterImportSubmit()}
        positiveButtonText="Import"
        negativeButtonText="Close"
        disabledPositiveBtn={disableMasterImport}
        maxWidth={'95%'}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {selectedTerm?.masterData ? (
              <>
                <div
                  style={{ justifyContent: 'space-between', display: 'flex' }}
                >
                  <span style={{ color: '#092682', font: 'Open Sans' }}>
                    {selectedTerm?.masterData?.courseName}
                  </span>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      handleAddToMasterImport(selectedTerm?.masterData?.array)
                    }
                  >
                    Add
                  </Button>
                </div>
                <Grid item xs={12} style={{ marginTop: 10 }}>
                  <div className="masterSubject-table">
                    <KenGrid
                      columns={masterHead}
                      data={selectedTerm?.masterData?.array}
                      pagination={{ disabled: true }}
                      toolbarDisabled={true}
                      isCollasable={true}
                      component={CollapseData}
                    />
                  </div>
                </Grid>
              </>
            ) : (
              <>Master Data not found</>
            )}
          </Grid>
        </Grid>
      </KenDialog>
      {/* Section View */}
      <KenDialog
        title={
          <>
            <Typography variant="h6" className={classes.dialogHeader}>
              Select Section
            </Typography>
          </>
        }
        open={sectionViewDialog}
        icon={<RiCheckFill />}
        handleClose={() => sectionViewCancel()}
        negativeButtonClick={() => sectionViewCancel()}
        positiveButtonClick={() => sectionViewSubmit()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        hidePositiveButton={true}
        style={{ width: '80%' }}
        dividers
      >
        <Grid container xs={12}>
          <Grid xs={12}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                <TableHead>
                  <TableRow>
                    {sectionArray.map((ele) => (
                      <TableCell align="left">{ele}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sectionData?.length > 0 ? (
                    sectionData.map((row, index) => {
                      return (
                        <TableRow key={row.id}>
                          <KenGridEditable
                            {...{
                              row,
                              onChange,
                              editCell,
                              columns: [
                                {
                                  column_name: 'checkbox',
                                  is_inline_edit: false,
                                  inline_edit_type: 'kenCheckbox',
                                },
                                {
                                  column_name: 'section',
                                  is_inline_edit: false,
                                  inline_edit_type: '',
                                },
                                {
                                  column_name: 'sectionStrength',
                                  is_inline_edit: false,
                                  inline_edit_type: 'kenInput',
                                },
                                {
                                  column_name: 'facultyName',
                                  is_inline_edit: true,
                                  inline_edit_type: 'kenSelect',
                                  dropdown: currentSectionFacultyOptions,
                                },
                              ],
                            }}
                          />
                          <TableCell
                            className={classes.selectTableCell}
                            style={{ textAlign: 'center' }}
                          >
                            {row.isEditMode ? (
                              <>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() =>
                                    onToggleEditBtn('done', row, index)
                                  }
                                >
                                  Save
                                </Button>
                                <IconButton
                                  aria-label="revert"
                                  onClick={() =>
                                    onToggleRevertBtn(
                                      row.id,
                                      sectionData,
                                      index
                                    )
                                  }
                                >
                                  <RevertIcon />
                                </IconButton>
                              </>
                            ) : (
                              <>
                                {!row.saves && (
                                  <IconButton
                                    aria-label="edit"
                                    onClick={() =>
                                      onToggleEditBtn('edit', row, index)
                                    }
                                  >
                                    <EditIcon />
                                  </IconButton>
                                )}
                                {row.saves && (
                                  <>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      onClick={() =>
                                        onToggleSaveBtn(
                                          'save',
                                          sectionData,
                                          index
                                        )
                                      }
                                    >
                                      Save
                                    </Button>
                                    <IconButton
                                      aria-label="revert"
                                      onClick={() =>
                                        onToggleCancelBtn(
                                          row.id,
                                          sectionData,
                                          index
                                        )
                                      }
                                    >
                                      <RevertIcon />
                                    </IconButton>
                                  </>
                                )}
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <TableCell style={{ border: 'none' }}>
                      No Data Found
                    </TableCell>
                  )}
                </TableBody>
              </Table>
              <Grid container xs={12}>
                <Button
                  className={classes.filterButton}
                  variant="contained"
                  color="primary"
                  onClick={() => addToSectionData('add', sectionData)}
                  style={{ margin: '10px 5px' }}
                >
                  Add
                </Button>
                <Button
                  className={classes.filterButton}
                  variant="contained"
                  color="primary"
                  onClick={() => addToSectionData('delete', sectionData)}
                  disabled={activateDelete}
                  style={{ margin: '10px 5px' }}
                >
                  Delete
                </Button>
              </Grid>
            </TableContainer>
          </Grid>
        </Grid>
      </KenDialog>
      {/* Faculty View */}
      <KenDialog
        title={
          <>
            <Grid container>
              <Grid xs={4}>
                <Typography variant="h6" className={classes.dialogHeader}>
                  Select Faculty
                </Typography>
              </Grid>
              <Grid container xs={8} style={{ justifyContent: 'right' }}>
                <Button
                  className={classes.filterButton}
                  variant="contained"
                  color="primary"
                  onClick={() => history.push(routes.facultySection)}
                >
                  Invite Faculty
                </Button>
                <Button
                  className={classes.filterButton}
                  variant="contained"
                  color="primary"
                  onClick={addFacultyToAll}
                >
                  Add Faculty
                </Button>
              </Grid>
            </Grid>
          </>
        }
        open={facultyViewDialog}
        icon={<RiCheckFill />}
        handleClose={() => facultyViewCancel()}
        negativeButtonClick={() => facultyViewCancel()}
        positiveButtonClick={() => facultyViewSubmit()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        style={{ width: '80%' }}
        dividers
      >
        <Grid container xs={12}>
          <Grid xs={12}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                <TableHead>
                  <TableRow>
                    {facultyArray.map((ele) => (
                      <TableCell align="left">{ele}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {facultyData?.length > 0
                    ? facultyData.map((row, index) => {
                        return (
                          <TableRow key={row.id}>
                            <KenGridEditable
                              {...{
                                row,
                                onChange,
                                editCell,
                                columns: [
                                  {
                                    column_name: 'checkbox',
                                    is_inline_edit: false,
                                    inline_edit_type: 'kenCheckbox',
                                  },
                                  {
                                    column_name: 'section',
                                    is_inline_edit: false,
                                    inline_edit_type: '',
                                  },
                                  {
                                    column_name: 'sectionStrength',
                                    is_inline_edit: false,
                                    inline_edit_type: 'kenInput',
                                  },
                                  {
                                    column_name: 'facultyView',
                                    is_inline_edit: false,
                                    inline_edit_type: 'kenSelect',
                                    dropdown: facultyOptions,
                                  },
                                ],
                              }}
                            />
                            <TableCell
                              className={classes.selectTableCell}
                              style={{ textAlign: 'center' }}
                            >
                              {row.isEditMode ? (
                                <>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() =>
                                      onFacultyEditBtn('done', row.id, index)
                                    }
                                  >
                                    Save
                                  </Button>
                                  <IconButton
                                    aria-label="revert"
                                    onClick={() =>
                                      onFacultyRevertBtn(
                                        row.id,
                                        facultyData,
                                        index
                                      )
                                    }
                                  >
                                    <RevertIcon />
                                  </IconButton>
                                </>
                              ) : (
                                <>
                                  {!row.saves && (
                                    <IconButton
                                      aria-label="edit"
                                      onClick={() =>
                                        onFacultyEditBtn('edit', row.id, index)
                                      }
                                    >
                                      <EditIcon />
                                    </IconButton>
                                  )}
                                  {row.saves && (
                                    <>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                          onFacultySaveBtn(
                                            'save',
                                            facultyData,
                                            index
                                          )
                                        }
                                      >
                                        Save
                                      </Button>
                                      <IconButton
                                        aria-label="revert"
                                        onClick={() =>
                                          onFacultyCancelBtn(
                                            row.id,
                                            facultyData,
                                            index
                                          )
                                        }
                                      >
                                        <RevertIcon />
                                      </IconButton>
                                    </>
                                  )}
                                </>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </KenDialog>
      {/* Acivity View */}
      <KenDialog
        title={
          <>
            <Grid container>
              <Grid xs={4}>
                <Typography variant="h6" className={classes.dialogHeader}>
                  Select Activity
                </Typography>
              </Grid>
              <Grid container xs={8} style={{ justifyContent: 'right' }}>
                <Button
                  className={classes.filterButton}
                  variant="contained"
                  color="primary"
                  onClick={addActivityItem}
                >
                  Add Activity
                </Button>
              </Grid>
            </Grid>
          </>
        }
        open={activityViewDialog}
        icon={<RiCheckFill />}
        handleClose={() => activityViewCancel()}
        negativeButtonClick={() => activityViewCancel()}
        // positiveButtonClick={() => activityViewSubmit()}
        positiveButtonClick={() => {
          // history.push({
          //   pathname: `${routes.sessionScheduler}`,
          //   // state: {
          //   //   programName: programName,
          //   //   intake: intake,
          //   //   year: year,
          //   //   id: programID,
          //   // },
          // });
          window.open(`${routes.sessionScheduler}`, '_blank');
          setActivityViewDialog(false);
          sessionStorage.setItem('programName', programName);
          sessionStorage.setItem('intake', intake);
          sessionStorage.setItem('year', year);
        }}
        positiveButtonText="Next"
        negativeButtonText="Cancel"
        maxWidth={'100%'}
        dividers
      >
        <Grid container xs={12}>
          <AddActivity
            programName={programName}
            intake={intake}
            year={year}
            newAddActivity={newAddActivity}
            selectedRow={selectedRow}
            currentRow={currentRow}
            activitiesData={activitiesData}
            facultyOption={currentSectionFacultyOptions}
            createNewActivity={createNewActivity}
            setCreateNewActivity={setCreateNewActivity}
            onReload={onReload}
          />
          {activitiesData.length > 0 ? null : (
            <p className={classes.fetchingDetails}>{fetchingData}</p>
          )}
        </Grid>
      </KenDialog>
      {/* Add and Review Faculty */}
      <KenDialog
        title={
          <>
            <Grid container>
              <Grid xs={4}>
                <Typography variant="h6" className={classes.dialogHeader}>
                  Add/Review Faculty
                </Typography>
              </Grid>
              <Grid container xs={8} style={{ justifyContent: 'right' }}>
                <SearchBox
                  searchHandler={searchTable}
                  value={searchString}
                  disableFocus={true}
                />
              </Grid>
            </Grid>
          </>
        }
        open={reviewFacultyDialog}
        handleClose={() => reviewFacultyCancel()}
        negativeButtonClick={() => reviewFacultyCancel()}
        positiveButtonClick={() => reviewFacultySubmit()}
        positiveButtonText="Add Faculty"
        negativeButtonText="Cancel"
        maxWidth={'100%'}
        dividers
      >
        <Grid container xs={12}>
          <SubjectUsers
            variant={'Faculty'}
            addReviewedFaculty={handleClick}
            searchStringVal={searchString}
            sethandleClick={sethandleClick}
            triggerVal={trigger}
            selectedSubject={selectedSubject}
            rowSubject={rowSubject}
            setFacultyAdded={setFacultyAdded}
            setSelectedUser={setSelectedUser}
            checkAvailability={checkAvailability}
          />
        </Grid>
      </KenDialog>
      {/* Add Subject Button */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Add Subject
          </Typography>
        }
        open={addSubjectDialog}
        // icon={<RiCheckFill />}
        handleClose={() => handleAddSubjectCancel()}
        negativeButtonClick={() => handleAddSubjectCancel()}
        positiveButtonClick={() => handleSubject('save', addIntoTerm)}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        maxWidth="lg"
        dividers
      >
        <Grid container xs={12} spacing={2}>
          <Grid item xs={6}>
            <div className="autocomplete-select">
              <KenAutoComplete
                multiple={false}
                options={selectOptionsCourseNEW}
                name="courseName"
                label="Subject"
                value={dataSubject.courseName}
                variant="outlined"
                onChange={(e, value) => handleSelectChangeSubjectNEW(e, value)}
                required
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className="courseID-field">
              <KenInputField
                label={'Course ID'}
                value={dataSubject.courseId}
                optionalLabel={false}
                disabled={true}
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <KenDateTimePicker
              name={'startDate'}
              value={dataSubject.startDate}
              minDate={addIntoTerm.termStartDate}
              maxDate={addIntoTerm.termEndDate}
              label="Start date"
              type="date"
              required={true}
              onChange={(e) => handleChangedDate(e, addNewSubData)}
            />
          </Grid>
          <Grid item xs={6}>
            <KenDateTimePicker
              name={'endDate'}
              placeholder="Start Time"
              label="End date"
              value={dataSubject.endDate}
              minDate={addIntoTerm.termStartDate}
              maxDate={addIntoTerm.termEndDate}
              type="date"
              required={true}
              onChange={(e) => handleChangedEndDate(e)}
            />
          </Grid>
          <Grid item xs={12}>
            <div className="autocomplete-select">
              <KenAutoComplete
                options={facultyOptions}
                name="facultyList"
                label="Faculty"
                value={dataSubject.facultyList}
                variant="outlined"
                onChange={(e, value) => handleChangeFaculty(e, value)}
                required
              />
            </div>
          </Grid>
        </Grid>
      </KenDialogBox>
      {/* Facility Popup */}
      <KenDialog
        title={
          <>
            <Grid container>
              <Grid xs={4}>
                <Typography variant="h6" className={classes.dialogHeader}>
                  Resource Calendar
                </Typography>
              </Grid>
              <Grid container xs={8} style={{ justifyContent: 'right' }}>
                {serviceTabs?.map((item) => {
                  return (
                    <Button
                      name={item.title}
                      className={
                        itemIndex === item.index
                          ? classes.activeBtn
                          : classes.defaultBtn
                      }
                      onClick={(e) => {
                        currentDataRequirement(item);
                      }}
                    >
                      {item.title}
                    </Button>
                  );
                })}
              </Grid>
            </Grid>
          </>
        }
        open={reviewFacilityDialog}
        handleClose={() => reviewFacilityCancel()}
        negativeButtonClick={() => reviewFacilityCancel()}
        positiveButtonClick={() => reviewFacilitySubmit()}
        positiveButtonText="Add Facility"
        negativeButtonText="Cancel"
        hidePositiveButton={resourceType === 'faculty' ? true : false}
        disabledPositiveBtn={disableBtn}
        maxWidth={'100%'}
        dividers
      >
        <Grid container xs={12}>
          <ResourceCalendar
            id={contactId}
            selectedRowData={facilityCell}
            resourceType={resourceType}
            setDisableBtn={setDisableBtn}
            activitiesData={activitiesData}
            calendarType={'AcademicPlanner'}
            currentSelected={currentSelected}
            setResourceType={setResourceType}
            setFacilitySelected={setFacilitySelected}
          />
        </Grid>
      </KenDialog>
      {/* Holiday Listing Popup */}
      <KenDialog
        title={
          <>
            <Grid container>
              <Grid xs={4}>
                <Typography variant="h6" className={classes.dialogHeader}>
                  Campus Holidays - {holidayListData[0]?.campusName}
                </Typography>
              </Grid>
            </Grid>
          </>
        }
        open={holidayListingDialog}
        handleClose={() => holidayListingCancel()}
        negativeButtonClick={() => holidayListingCancel()}
        positiveButtonClick={() => holidayListingSubmit()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        hidePositiveButton={true}
        maxWidth={'50%'}
        dividers
      >
        <Grid container xs={12}>
          {/* holiday list data */}
          <Table>
            <TableHead>
              <TableCell>Holiday</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell>End Date</TableCell>
            </TableHead>
            <TableBody>
              {holidayListData.length > 0
                ? holidayListData.map((item) => {
                    return (
                      <TableRow>
                        <TableCell>{item.holidayName}</TableCell>
                        <TableCell>
                          {moment(item.startDate, 'YYY-MM-DD').format('DD-MMM')}
                        </TableCell>
                        <TableCell>
                          {moment(item.endDate, 'YYY-MM-DD').format('DD-MMM')}
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </Grid>
      </KenDialog>
      {/* Faculty Profile Popup */}
      <KenDialog
        title={
          <>
            <Grid container>
              <Grid xs={4}>
                <Typography variant="h6" className={classes.dialogHeader}>
                  Faculty Profile
                </Typography>
              </Grid>
            </Grid>
          </>
        }
        open={facultyProfileDialog}
        handleClose={() => facultyProfileCancel()}
        negativeButtonClick={() => facultyProfileCancel()}
        positiveButtonClick={() => facultyProfileSubmit()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        hidePositiveButton={true}
        maxWidth={'96%'}
        dividers
      >
        <Grid container xs={12}>
          {/* holiday list data */}
          {profileData.length > 0 ? (
            <FacultyProfile
              state={{ contactId: profileData[0]?.value }}
              selectedRowData={facilityCell}
            />
          ) : null}
        </Grid>
      </KenDialog>
      {/* Faculty Availability Popup */}
      <KenDialog
        title={
          <>
            <Grid container>
              <Grid xs={4}>
                <Typography variant="h6" className={classes.dialogHeader}>
                  Faculty Booking - {selectedFaculty?.title}
                </Typography>
              </Grid>
              <Grid xs={8} style={{ textAlignLast: 'right' }}>
                {serviceTabs?.map((item) => {
                  return (
                    <Button
                      name={item.title}
                      className={
                        itemIndex === item.index
                          ? classes.activeBtn
                          : classes.defaultBtn
                      }
                      onClick={(e) => {
                        currentDataRequirement(item);
                      }}
                    >
                      {item.title}
                    </Button>
                  );
                })}
              </Grid>
            </Grid>
          </>
        }
        open={facultyAvailabilityPopup}
        handleClose={() => facultyAvailabilityCancel()}
        negativeButtonClick={() => facultyAvailabilityCancel()}
        positiveButtonClick={() => facultyAvailabilitySubmit()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        hidePositiveButton={true}
        maxWidth={'96%'}
        dividers
      >
        <Grid container xs={12}>
          <Grid item xs={12} style={{ paddingRight: 10 }}>
            {/* <Typography>Faculty Booking</Typography> */}
            <div className="facultyBookingTable">
              <KenGrid
                columns={facultyBooking}
                data={facultyBookingData}
                pagination={{ disabled: true }}
                toolbarDisabled={true}
              />
            </div>
          </Grid>
        </Grid>
      </KenDialog>
      {/* Academic Calendar Popup */}
      <KenDialog
        title={
          <>
            <Grid container>
              <Grid xs={4}>
                <Typography variant="h6" className={classes.dialogHeader}>
                  Academic Calendar
                </Typography>
              </Grid>
            </Grid>
          </>
        }
        open={showAcademicCalendarPopup}
        handleClose={() => academicCalendarCancel()}
        negativeButtonClick={() => academicCalendarCancel()}
        positiveButtonClick={() => academicCalendarSubmit()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        hidePositiveButton={true}
        maxWidth={'96%'}
        dividers
      >
        <Grid container xs={12}>
          <AcademicCalendar
            programValue={programValue}
            programPlanval={programPlanval}
          />
        </Grid>
      </KenDialog>
      {/* Add to Master Import Popup */}
      <KenDialog
        title={
          <>
            <Grid container>
              <Grid xs={4}>
                <Typography variant="h6" className={classes.dialogHeader}>
                  Add to Master Import
                </Typography>
              </Grid>
            </Grid>
          </>
        }
        open={showAddMasterImport}
        handleClose={() => addMasterClose()}
        negativeButtonClick={() => addMasterClose()}
        positiveButtonClick={() => addNewMaster()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        hidePositiveButton={false}
        maxWidth="lg"
        dividers
      >
        <Grid container xs={12}>
          <AddMasterImport
            selectedTerm={selectedTerm}
            proceedMaster={proceedMaster}
            setProceedMaster={setProceedMaster}
            setShowAddMasterImport={setShowAddMasterImport}
            programID={programID}
            setNewMasterUpload={setNewMasterUpload}
          />
        </Grid>
      </KenDialog>
    </Box>
  );
};
// Collapse Column for Master Term Import
const CollapseData = (props) => {
  console.log('props', props);
  const propsData = props?.original;
  const classes = useStyles();
  const [previewData, setPreviewData] = useState([]);
  const [loader, setLoader] = React.useState(false);
  const masterHead = [
    // {
    //   Header: 'Week No.',
    //   accessor: 'weekNo',
    //   disableGlobalFilter: false,
    // },
    {
      Header: 'Activity',
      accessor: 'activityName',
      disableGlobalFilter: false,
    },
    // {
    //   Header: 'Subject Code',
    //   accessor: 'subjectCode',
    //   disableGlobalFilter: false,
    // },
    {
      Header: 'Subject',
      accessor: 'subject',
      disableGlobalFilter: false,
    },
    {
      Header: 'Faculty',
      accessor: 'facultyList',
      disableGlobalFilter: false,
    },
    // {
    //   Header: 'Start Date',
    //   accessor: 'startDate1',
    //   disableGlobalFilter: false,
    // },
    // {
    //   Header: 'End Date',
    //   accessor: 'endDate1',
    //   disableGlobalFilter: false,
    // },
  ];

  return (
    <div>
      {loader ? <KenLoader /> : null}
      <Grid item xs={12}>
        <KenGrid
          columns={masterHead}
          data={propsData?.activitesList}
          pagination={{ disabled: true }}
          toolbarDisabled={true}
        />
      </Grid>
    </div>
  );
};
export default AddSubject;
